import { _TypedDataEncoder, hashMessage } from '@ethersproject/hash';
import globalAxios, { isAxiosError } from 'axios';
import { StaticJsonRpcProvider } from '@ethersproject/providers';
import { hexlify, joinSignature, arrayify } from '@ethersproject/bytes';
import { EventEmitter } from 'events';
import { v4 } from 'uuid';
import { importJWK, jwtVerify, errors } from 'jose';
import * as crypto from 'crypto';
import { secp256k1 } from '@noble/curves/secp256k1';
import { SigningKey } from '@ethersproject/signing-key';
import { computeAddress } from '@ethersproject/transactions';

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const BASE_PATH = "https://api.openfort.xyz".replace(/\/+$/, "");
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    basePath;
    axios;
    configuration;
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    field;
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
const DUMMY_BASE_URL = 'https://example.com';
/**
 *
 * @throws {RequiredError}
 * @export
 */
const assertParamExists = function (functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
};
/**
 *
 * @export
 */
const setBearerAuthToObject = async function (object, configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
};
function setFlattenedQueryParams(urlSearchParams, parameter, key = "") {
    if (parameter == null)
        return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            parameter.forEach(item => setFlattenedQueryParams(urlSearchParams, item, key));
        }
        else {
            Object.keys(parameter).forEach(currentKey => setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== '' ? '.' : ''}${currentKey}`));
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}
/**
 *
 * @export
 */
const setSearchParams = function (url, ...objects) {
    const searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */
const serializeDataIfNeeded = function (value, requestOptions, configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
};
/**
 *
 * @export
 */
const toPathString = function (url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */
const createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
    return (axios = globalAxios, basePath = BASE_PATH) => {
        const axiosRequestArgs = { ...axiosArgs.options, url: (configuration?.basePath || axios.defaults.baseURL || basePath) + axiosArgs.url };
        return axios.request(axiosRequestArgs);
    };
};

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * AccountsApi - axios parameter creator
 * @export
 */
const AccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Cancel a pending transfer of ownership.
         * @summary Cancel request to transfer ownership of an account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {CancelTransferOwnershipRequest} cancelTransferOwnershipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransferOwnership: async (id, cancelTransferOwnershipRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelTransferOwnership', 'id', id);
            // verify required parameter 'cancelTransferOwnershipRequest' is not null or undefined
            assertParamExists('cancelTransferOwnership', 'cancelTransferOwnershipRequest', cancelTransferOwnershipRequest);
            const localVarPath = `/v1/accounts/{id}/cancel_transfer_ownership`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(cancelTransferOwnershipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Complete a recovery process of a recoverable account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {CompleteRecoveryRequest} completeRecoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRecovery: async (id, completeRecoveryRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeRecovery', 'id', id);
            // verify required parameter 'completeRecoveryRequest' is not null or undefined
            assertParamExists('completeRecovery', 'completeRecoveryRequest', completeRecoveryRequest);
            const localVarPath = `/v1/accounts/{id}/complete_recovery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(completeRecoveryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new blockchain account for the provided player. If not player is provided, a new one will be created.  Account creation does not consume any gas. All accounts of a player will use the same address across blockchains.  Each player can only have one account per chain.
         * @summary Create an account object.
         * @param {CreateAccountRequest} createAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (createAccountRequest, options = {}) => {
            // verify required parameter 'createAccountRequest' is not null or undefined
            assertParamExists('createAccount', 'createAccountRequest', createAccountRequest);
            const localVarPath = `/v1/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint can be used to deploy a smart contract account that was counterfactually generated.
         * @summary Deploy an account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {DeployRequest} deployRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployAccount: async (id, deployRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deployAccount', 'id', id);
            // verify required parameter 'deployRequest' is not null or undefined
            assertParamExists('deployAccount', 'deployRequest', deployRequest);
            const localVarPath = `/v1/accounts/{id}/deploy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(deployRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of an existing account.  Supply the unique account ID from either a account creation request or the account list, and Openfort will return the corresponding account information.  Returns the latest 10 transaction intents created by this account.
         * @summary Get existing account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {Array<AccountResponseExpandable>} [expand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (id, expand, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccount', 'id', id);
            const localVarPath = `/v1/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of accounts for the given player.  This object represents a player\'s account, which is a blockchain smart account that can be used to interact with the blockchain.  The accounts are returned sorted by creation date, with the most recently created accounts appearing first.  Returns the latest 10 transaction intents for each account.  By default, a maximum of 10 accounts are shown per page.
         * @summary List accounts of a player.
         * @param {string} player Specifies the unique player ID (starts with pla_)
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<AccountResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (player, limit, skip, order, expand, options = {}) => {
            // verify required parameter 'player' is not null or undefined
            assertParamExists('getAccounts', 'player', player);
            const localVarPath = `/v1/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            if (player !== undefined) {
                localVarQueryParameter['player'] = player;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform a request to change the owner of an account.  To perform an update on the owner of an account, first you must provide a new owner address. Once requested, the owner must accept to take ownership by calling `acceptOwnership()` in the smart contract account.
         * @summary Request transfer ownership of account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {TransferOwnershipRequest} transferOwnershipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTransferOwnership: async (id, transferOwnershipRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestTransferOwnership', 'id', id);
            // verify required parameter 'transferOwnershipRequest' is not null or undefined
            assertParamExists('requestTransferOwnership', 'transferOwnershipRequest', transferOwnershipRequest);
            const localVarPath = `/v1/accounts/{id}/request_transfer_ownership`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(transferOwnershipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Custodial Accounts only** - Signs the typed repositories value with types repositories structure for domain using the [EIP-712](https://eips.ethereum.org/EIPS/eip-712) specification.
         * @summary Sign a given payload
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {SignPayloadRequest} signPayloadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signPayload: async (id, signPayloadRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('signPayload', 'id', id);
            // verify required parameter 'signPayloadRequest' is not null or undefined
            assertParamExists('signPayload', 'signPayloadRequest', signPayloadRequest);
            const localVarPath = `/v1/accounts/{id}/sign_payload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(signPayloadRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start a recovery process of a recoverable account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {StartRecoveryRequest} startRecoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRecovery: async (id, startRecoveryRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startRecovery', 'id', id);
            // verify required parameter 'startRecoveryRequest' is not null or undefined
            assertParamExists('startRecovery', 'startRecoveryRequest', startRecoveryRequest);
            const localVarPath = `/v1/accounts/{id}/start_recovery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(startRecoveryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronize the account state with the blockchain. Specifically, it updates the account owner and whether its deployed or not.
         * @summary Sync account state with the blockchain
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncAccount', 'id', id);
            const localVarPath = `/v1/accounts/{id}/sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountsApi - functional programming interface
 * @export
 */
const AccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration);
    return {
        /**
         * Cancel a pending transfer of ownership.
         * @summary Cancel request to transfer ownership of an account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {CancelTransferOwnershipRequest} cancelTransferOwnershipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTransferOwnership(id, cancelTransferOwnershipRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTransferOwnership(id, cancelTransferOwnershipRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Complete a recovery process of a recoverable account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {CompleteRecoveryRequest} completeRecoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRecovery(id, completeRecoveryRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRecovery(id, completeRecoveryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new blockchain account for the provided player. If not player is provided, a new one will be created.  Account creation does not consume any gas. All accounts of a player will use the same address across blockchains.  Each player can only have one account per chain.
         * @summary Create an account object.
         * @param {CreateAccountRequest} createAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(createAccountRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(createAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint can be used to deploy a smart contract account that was counterfactually generated.
         * @summary Deploy an account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {DeployRequest} deployRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployAccount(id, deployRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployAccount(id, deployRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of an existing account.  Supply the unique account ID from either a account creation request or the account list, and Openfort will return the corresponding account information.  Returns the latest 10 transaction intents created by this account.
         * @summary Get existing account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {Array<AccountResponseExpandable>} [expand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(id, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(id, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of accounts for the given player.  This object represents a player\'s account, which is a blockchain smart account that can be used to interact with the blockchain.  The accounts are returned sorted by creation date, with the most recently created accounts appearing first.  Returns the latest 10 transaction intents for each account.  By default, a maximum of 10 accounts are shown per page.
         * @summary List accounts of a player.
         * @param {string} player Specifies the unique player ID (starts with pla_)
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<AccountResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(player, limit, skip, order, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(player, limit, skip, order, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Perform a request to change the owner of an account.  To perform an update on the owner of an account, first you must provide a new owner address. Once requested, the owner must accept to take ownership by calling `acceptOwnership()` in the smart contract account.
         * @summary Request transfer ownership of account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {TransferOwnershipRequest} transferOwnershipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTransferOwnership(id, transferOwnershipRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTransferOwnership(id, transferOwnershipRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * **Custodial Accounts only** - Signs the typed repositories value with types repositories structure for domain using the [EIP-712](https://eips.ethereum.org/EIPS/eip-712) specification.
         * @summary Sign a given payload
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {SignPayloadRequest} signPayloadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signPayload(id, signPayloadRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signPayload(id, signPayloadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Start a recovery process of a recoverable account.
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {StartRecoveryRequest} startRecoveryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRecovery(id, startRecoveryRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRecovery(id, startRecoveryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Synchronize the account state with the blockchain. Specifically, it updates the account owner and whether its deployed or not.
         * @summary Sync account state with the blockchain
         * @param {string} id Specifies the unique account ID (starts with acc_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
class AccountsApi extends BaseAPI {
    /**
     * Cancel a pending transfer of ownership.
     * @summary Cancel request to transfer ownership of an account.
     * @param {AccountsApiCancelTransferOwnershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    cancelTransferOwnership(requestParameters, options) {
        return AccountsApiFp(this.configuration).cancelTransferOwnership(requestParameters.id, requestParameters.cancelTransferOwnershipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Complete a recovery process of a recoverable account.
     * @param {AccountsApiCompleteRecoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    completeRecovery(requestParameters, options) {
        return AccountsApiFp(this.configuration).completeRecovery(requestParameters.id, requestParameters.completeRecoveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new blockchain account for the provided player. If not player is provided, a new one will be created.  Account creation does not consume any gas. All accounts of a player will use the same address across blockchains.  Each player can only have one account per chain.
     * @summary Create an account object.
     * @param {AccountsApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    createAccount(requestParameters, options) {
        return AccountsApiFp(this.configuration).createAccount(requestParameters.createAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint can be used to deploy a smart contract account that was counterfactually generated.
     * @summary Deploy an account.
     * @param {AccountsApiDeployAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    deployAccount(requestParameters, options) {
        return AccountsApiFp(this.configuration).deployAccount(requestParameters.id, requestParameters.deployRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the details of an existing account.  Supply the unique account ID from either a account creation request or the account list, and Openfort will return the corresponding account information.  Returns the latest 10 transaction intents created by this account.
     * @summary Get existing account.
     * @param {AccountsApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccount(requestParameters, options) {
        return AccountsApiFp(this.configuration).getAccount(requestParameters.id, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of accounts for the given player.  This object represents a player\'s account, which is a blockchain smart account that can be used to interact with the blockchain.  The accounts are returned sorted by creation date, with the most recently created accounts appearing first.  Returns the latest 10 transaction intents for each account.  By default, a maximum of 10 accounts are shown per page.
     * @summary List accounts of a player.
     * @param {AccountsApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccounts(requestParameters, options) {
        return AccountsApiFp(this.configuration).getAccounts(requestParameters.player, requestParameters.limit, requestParameters.skip, requestParameters.order, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Perform a request to change the owner of an account.  To perform an update on the owner of an account, first you must provide a new owner address. Once requested, the owner must accept to take ownership by calling `acceptOwnership()` in the smart contract account.
     * @summary Request transfer ownership of account.
     * @param {AccountsApiRequestTransferOwnershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    requestTransferOwnership(requestParameters, options) {
        return AccountsApiFp(this.configuration).requestTransferOwnership(requestParameters.id, requestParameters.transferOwnershipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Custodial Accounts only** - Signs the typed repositories value with types repositories structure for domain using the [EIP-712](https://eips.ethereum.org/EIPS/eip-712) specification.
     * @summary Sign a given payload
     * @param {AccountsApiSignPayloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    signPayload(requestParameters, options) {
        return AccountsApiFp(this.configuration).signPayload(requestParameters.id, requestParameters.signPayloadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start a recovery process of a recoverable account.
     * @param {AccountsApiStartRecoveryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    startRecovery(requestParameters, options) {
        return AccountsApiFp(this.configuration).startRecovery(requestParameters.id, requestParameters.startRecoveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Synchronize the account state with the blockchain. Specifically, it updates the account owner and whether its deployed or not.
     * @summary Sync account state with the blockchain
     * @param {AccountsApiSyncAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    syncAccount(requestParameters, options) {
        return AccountsApiFp(this.configuration).syncAccount(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Deprecated
         * @summary Authenticate player with oauth token.
         * @param {AuthenticateOAuthRequest} authenticateOAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authenticateOAuth: async (authenticateOAuthRequest, options = {}) => {
            // verify required parameter 'authenticateOAuthRequest' is not null or undefined
            assertParamExists('authenticateOAuth', 'authenticateOAuthRequest', authenticateOAuthRequest);
            const localVarPath = `/iam/v1/oauth/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateOAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Authenticate player with SIWE
         * @param {SIWEAuthenticateRequest} sIWEAuthenticateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateSIWE: async (sIWEAuthenticateRequest, options = {}) => {
            // verify required parameter 'sIWEAuthenticateRequest' is not null or undefined
            assertParamExists('authenticateSIWE', 'sIWEAuthenticateRequest', sIWEAuthenticateRequest);
            const localVarPath = `/iam/v1/siwe/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sIWEAuthenticateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AuthorizePlayerRequest} authorizePlayerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize: async (authorizePlayerRequest, options = {}) => {
            // verify required parameter 'authorizePlayerRequest' is not null or undefined
            assertParamExists('authorize', 'authorizePlayerRequest', authorizePlayerRequest);
            const localVarPath = `/iam/v1/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(authorizePlayerRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The endpoint verifies the token generated by OAuth provider, creates or retrieves a player based on his email, and returns the jwt token for the player together with the player id.
         * @summary Authorize player with token.
         * @param {AuthProvider} provider OAuth provider
         * @param {OAuthRequest} oAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        authorizeWithOAuthToken: async (provider, oAuthRequest, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('authorizeWithOAuthToken', 'provider', provider);
            // verify required parameter 'oAuthRequest' is not null or undefined
            assertParamExists('authorizeWithOAuthToken', 'oAuthRequest', oAuthRequest);
            const localVarPath = `/iam/v1/oauth/{provider}/authorize`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the jwks.json file.  You can use the jwks.json file to verify the signature of a JWT token issued by Openfort Auth.
         * @summary Get the jwks.json file.
         * @param {string} publishableKey Specifies the project publishable key (starts with pk_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwks: async (publishableKey, options = {}) => {
            // verify required parameter 'publishableKey' is not null or undefined
            assertParamExists('getJwks', 'publishableKey', publishableKey);
            const localVarPath = `/iam/v1/{publishable_key}/jwks.json`
                .replace(`{${"publishable_key"}}`, encodeURIComponent(String(publishableKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initialize OAuth.
         * @param {OAuthInitRequest} oAuthInitRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOAuth: async (oAuthInitRequest, xGame, options = {}) => {
            // verify required parameter 'oAuthInitRequest' is not null or undefined
            assertParamExists('initOAuth', 'oAuthInitRequest', oAuthInitRequest);
            const localVarPath = `/iam/v1/oauth/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthInitRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a challenge to link external wallet to the player.
         * @summary Initialize SIWE.
         * @param {SIWERequest} sIWERequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSIWE: async (sIWERequest, xGame, options = {}) => {
            // verify required parameter 'sIWERequest' is not null or undefined
            assertParamExists('initSIWE', 'sIWERequest', sIWERequest);
            const localVarPath = `/iam/v1/siwe/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sIWERequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginRequest} loginRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkEmail: async (loginRequest, xGame, options = {}) => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('linkEmail', 'loginRequest', loginRequest);
            const localVarPath = `/iam/v1/password/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initialize Link OAuth.
         * @param {OAuthInitRequest} oAuthInitRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkOAuth: async (oAuthInitRequest, xGame, options = {}) => {
            // verify required parameter 'oAuthInitRequest' is not null or undefined
            assertParamExists('linkOAuth', 'oAuthInitRequest', oAuthInitRequest);
            const localVarPath = `/iam/v1/oauth/init_link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthInitRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Link external wallet.
         * @param {SIWEAuthenticateRequest} sIWEAuthenticateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkSIWE: async (sIWEAuthenticateRequest, options = {}) => {
            // verify required parameter 'sIWEAuthenticateRequest' is not null or undefined
            assertParamExists('linkSIWE', 'sIWEAuthenticateRequest', sIWEAuthenticateRequest);
            const localVarPath = `/iam/v1/siwe/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sIWEAuthenticateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate a player based on email and password.
         * @summary Email and password login.
         * @param {LoginRequest} loginRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailPassword: async (loginRequest, xGame, options = {}) => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('loginEmailPassword', 'loginRequest', loginRequest);
            const localVarPath = `/iam/v1/password/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When using Openfort Auth, the endpoint logs out the player.
         * @summary Log out a player.
         * @param {LogoutRequest} logoutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (logoutRequest, options = {}) => {
            // verify required parameter 'logoutRequest' is not null or undefined
            assertParamExists('logout', 'logoutRequest', logoutRequest);
            const localVarPath = `/iam/v1/sessions/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(logoutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options = {}) => {
            const localVarPath = `/iam/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initialize OAuth.
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolOAuth: async (key, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('poolOAuth', 'key', key);
            const localVarPath = `/iam/v1/oauth/pool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or create a new session for the player based on the refresh token.
         * @summary Refresh or create auth session.
         * @param {RefreshTokenRequest} refreshTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (refreshTokenRequest, options = {}) => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refresh', 'refreshTokenRequest', refreshTokenRequest);
            const localVarPath = `/iam/v1/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start the Email Verification process for a player.
         * @summary Request an Email Verification.
         * @param {RequestVerifyEmailRequest} requestVerifyEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailVerification: async (requestVerifyEmailRequest, options = {}) => {
            // verify required parameter 'requestVerifyEmailRequest' is not null or undefined
            assertParamExists('requestEmailVerification', 'requestVerifyEmailRequest', requestVerifyEmailRequest);
            const localVarPath = `/iam/v1/password/request_email_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestVerifyEmailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start the Reset process for a player\'s password.
         * @summary Request a Reset password.
         * @param {RequestResetPasswordRequest} requestResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPassword: async (requestResetPasswordRequest, options = {}) => {
            // verify required parameter 'requestResetPasswordRequest' is not null or undefined
            assertParamExists('requestResetPassword', 'requestResetPasswordRequest', requestResetPasswordRequest);
            const localVarPath = `/iam/v1/password/request_reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestResetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a player\'s password.
         * @summary Reset a password.
         * @param {ResetPasswordRequest} resetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest, options = {}) => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest);
            const localVarPath = `/iam/v1/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create and authenticate a player based on email and password.
         * @summary Email and password signup.
         * @param {SignupRequest} signupRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupEmailPassword: async (signupRequest, xGame, options = {}) => {
            // verify required parameter 'signupRequest' is not null or undefined
            assertParamExists('signupEmailPassword', 'signupRequest', signupRequest);
            const localVarPath = `/iam/v1/password/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(signupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify oauth token of a third party auth provider.
         * @param {ThirdPartyOAuthRequest} thirdPartyOAuthRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thirdParty: async (thirdPartyOAuthRequest, xGame, options = {}) => {
            // verify required parameter 'thirdPartyOAuthRequest' is not null or undefined
            assertParamExists('thirdParty', 'thirdPartyOAuthRequest', thirdPartyOAuthRequest);
            const localVarPath = `/iam/v1/oauth/third_party`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xGame != null) {
                localVarHeaderParameter['x-game'] = String(xGame);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(thirdPartyOAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UnlinkEmailRequest} unlinkEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkEmail: async (unlinkEmailRequest, options = {}) => {
            // verify required parameter 'unlinkEmailRequest' is not null or undefined
            assertParamExists('unlinkEmail', 'unlinkEmailRequest', unlinkEmailRequest);
            const localVarPath = `/iam/v1/password/unlink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(unlinkEmailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unlink OAuth account
         * @param {UnlinkOAuthRequest} unlinkOAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkOAuth: async (unlinkOAuthRequest, options = {}) => {
            // verify required parameter 'unlinkOAuthRequest' is not null or undefined
            assertParamExists('unlinkOAuth', 'unlinkOAuthRequest', unlinkOAuthRequest);
            const localVarPath = `/iam/v1/oauth/unlink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(unlinkOAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unlink external wallet.
         * @param {SIWERequest} sIWERequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkSIWE: async (sIWERequest, options = {}) => {
            // verify required parameter 'sIWERequest' is not null or undefined
            assertParamExists('unlinkSIWE', 'sIWERequest', sIWERequest);
            const localVarPath = `/iam/v1/siwe/unlink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sIWERequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify a player\'s email address.
         * @summary Verify an email.
         * @param {VerifyEmailRequest} verifyEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (verifyEmailRequest, options = {}) => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('verifyEmail', 'verifyEmailRequest', verifyEmailRequest);
            const localVarPath = `/iam/v1/password/verify_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
         * @summary Retrieve player by token.
         * @param {AuthProvider} provider OAuth provider
         * @param {OAuthRequest} oAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        verifyOAuth: async (provider, oAuthRequest, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('verifyOAuth', 'provider', provider);
            // verify required parameter 'oAuthRequest' is not null or undefined
            assertParamExists('verifyOAuth', 'oAuthRequest', oAuthRequest);
            const localVarPath = `/iam/v1/oauth/{provider}/verify`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
         * @summary Retrieve player by oauth token.
         * @param {AuthenticateOAuthRequest} authenticateOAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOAuthToken: async (authenticateOAuthRequest, options = {}) => {
            // verify required parameter 'authenticateOAuthRequest' is not null or undefined
            assertParamExists('verifyOAuthToken', 'authenticateOAuthRequest', authenticateOAuthRequest);
            const localVarPath = `/iam/v1/oauth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateOAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
const AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         * Deprecated
         * @summary Authenticate player with oauth token.
         * @param {AuthenticateOAuthRequest} authenticateOAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async authenticateOAuth(authenticateOAuthRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateOAuth(authenticateOAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Authenticate player with SIWE
         * @param {SIWEAuthenticateRequest} sIWEAuthenticateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateSIWE(sIWEAuthenticateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateSIWE(sIWEAuthenticateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {AuthorizePlayerRequest} authorizePlayerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorize(authorizePlayerRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorize(authorizePlayerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The endpoint verifies the token generated by OAuth provider, creates or retrieves a player based on his email, and returns the jwt token for the player together with the player id.
         * @summary Authorize player with token.
         * @param {AuthProvider} provider OAuth provider
         * @param {OAuthRequest} oAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async authorizeWithOAuthToken(provider, oAuthRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeWithOAuthToken(provider, oAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the jwks.json file.  You can use the jwks.json file to verify the signature of a JWT token issued by Openfort Auth.
         * @summary Get the jwks.json file.
         * @param {string} publishableKey Specifies the project publishable key (starts with pk_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJwks(publishableKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJwks(publishableKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Initialize OAuth.
         * @param {OAuthInitRequest} oAuthInitRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initOAuth(oAuthInitRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initOAuth(oAuthInitRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a challenge to link external wallet to the player.
         * @summary Initialize SIWE.
         * @param {SIWERequest} sIWERequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initSIWE(sIWERequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initSIWE(sIWERequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {LoginRequest} loginRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkEmail(loginRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkEmail(loginRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Initialize Link OAuth.
         * @param {OAuthInitRequest} oAuthInitRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkOAuth(oAuthInitRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkOAuth(oAuthInitRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Link external wallet.
         * @param {SIWEAuthenticateRequest} sIWEAuthenticateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkSIWE(sIWEAuthenticateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkSIWE(sIWEAuthenticateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate a player based on email and password.
         * @summary Email and password login.
         * @param {LoginRequest} loginRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginEmailPassword(loginRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginEmailPassword(loginRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * When using Openfort Auth, the endpoint logs out the player.
         * @summary Log out a player.
         * @param {LogoutRequest} logoutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(logoutRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(logoutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Initialize OAuth.
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolOAuth(key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolOAuth(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get or create a new session for the player based on the refresh token.
         * @summary Refresh or create auth session.
         * @param {RefreshTokenRequest} refreshTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(refreshTokenRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start the Email Verification process for a player.
         * @summary Request an Email Verification.
         * @param {RequestVerifyEmailRequest} requestVerifyEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestEmailVerification(requestVerifyEmailRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestEmailVerification(requestVerifyEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Start the Reset process for a player\'s password.
         * @summary Request a Reset password.
         * @param {RequestResetPasswordRequest} requestResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestResetPassword(requestResetPasswordRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestResetPassword(requestResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset a player\'s password.
         * @summary Reset a password.
         * @param {ResetPasswordRequest} resetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create and authenticate a player based on email and password.
         * @summary Email and password signup.
         * @param {SignupRequest} signupRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signupEmailPassword(signupRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signupEmailPassword(signupRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Verify oauth token of a third party auth provider.
         * @param {ThirdPartyOAuthRequest} thirdPartyOAuthRequest
         * @param {string} [xGame]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thirdParty(thirdPartyOAuthRequest, xGame, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thirdParty(thirdPartyOAuthRequest, xGame, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UnlinkEmailRequest} unlinkEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkEmail(unlinkEmailRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkEmail(unlinkEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unlink OAuth account
         * @param {UnlinkOAuthRequest} unlinkOAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkOAuth(unlinkOAuthRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkOAuth(unlinkOAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unlink external wallet.
         * @param {SIWERequest} sIWERequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkSIWE(sIWERequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkSIWE(sIWERequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify a player\'s email address.
         * @summary Verify an email.
         * @param {VerifyEmailRequest} verifyEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(verifyEmailRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(verifyEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
         * @summary Retrieve player by token.
         * @param {AuthProvider} provider OAuth provider
         * @param {OAuthRequest} oAuthRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async verifyOAuth(provider, oAuthRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOAuth(provider, oAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
         * @summary Retrieve player by oauth token.
         * @param {AuthenticateOAuthRequest} authenticateOAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOAuthToken(authenticateOAuthRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOAuthToken(authenticateOAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
class AuthenticationApi extends BaseAPI {
    /**
     * Deprecated
     * @summary Authenticate player with oauth token.
     * @param {AuthenticationApiAuthenticateOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authenticateOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).authenticateOAuth(requestParameters.authenticateOAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Authenticate player with SIWE
     * @param {AuthenticationApiAuthenticateSIWERequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authenticateSIWE(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).authenticateSIWE(requestParameters.sIWEAuthenticateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthenticationApiAuthorizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authorize(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).authorize(requestParameters.authorizePlayerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The endpoint verifies the token generated by OAuth provider, creates or retrieves a player based on his email, and returns the jwt token for the player together with the player id.
     * @summary Authorize player with token.
     * @param {AuthenticationApiAuthorizeWithOAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authorizeWithOAuthToken(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).authorizeWithOAuthToken(requestParameters.provider, requestParameters.oAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the jwks.json file.  You can use the jwks.json file to verify the signature of a JWT token issued by Openfort Auth.
     * @summary Get the jwks.json file.
     * @param {AuthenticationApiGetJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    getJwks(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).getJwks(requestParameters.publishableKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initialize OAuth.
     * @param {AuthenticationApiInitOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    initOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).initOAuth(requestParameters.oAuthInitRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a challenge to link external wallet to the player.
     * @summary Initialize SIWE.
     * @param {AuthenticationApiInitSIWERequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    initSIWE(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).initSIWE(requestParameters.sIWERequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthenticationApiLinkEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    linkEmail(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).linkEmail(requestParameters.loginRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initialize Link OAuth.
     * @param {AuthenticationApiLinkOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    linkOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).linkOAuth(requestParameters.oAuthInitRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Link external wallet.
     * @param {AuthenticationApiLinkSIWERequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    linkSIWE(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).linkSIWE(requestParameters.sIWEAuthenticateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authenticate a player based on email and password.
     * @summary Email and password login.
     * @param {AuthenticationApiLoginEmailPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    loginEmailPassword(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).loginEmailPassword(requestParameters.loginRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * When using Openfort Auth, the endpoint logs out the player.
     * @summary Log out a player.
     * @param {AuthenticationApiLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    logout(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).logout(requestParameters.logoutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    me(options) {
        return AuthenticationApiFp(this.configuration).me(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initialize OAuth.
     * @param {AuthenticationApiPoolOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    poolOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).poolOAuth(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get or create a new session for the player based on the refresh token.
     * @summary Refresh or create auth session.
     * @param {AuthenticationApiRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    refresh(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).refresh(requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the Email Verification process for a player.
     * @summary Request an Email Verification.
     * @param {AuthenticationApiRequestEmailVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    requestEmailVerification(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).requestEmailVerification(requestParameters.requestVerifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the Reset process for a player\'s password.
     * @summary Request a Reset password.
     * @param {AuthenticationApiRequestResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    requestResetPassword(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).requestResetPassword(requestParameters.requestResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reset a player\'s password.
     * @summary Reset a password.
     * @param {AuthenticationApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    resetPassword(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).resetPassword(requestParameters.resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create and authenticate a player based on email and password.
     * @summary Email and password signup.
     * @param {AuthenticationApiSignupEmailPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    signupEmailPassword(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).signupEmailPassword(requestParameters.signupRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify oauth token of a third party auth provider.
     * @param {AuthenticationApiThirdPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    thirdParty(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).thirdParty(requestParameters.thirdPartyOAuthRequest, requestParameters.xGame, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthenticationApiUnlinkEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    unlinkEmail(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).unlinkEmail(requestParameters.unlinkEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unlink OAuth account
     * @param {AuthenticationApiUnlinkOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    unlinkOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).unlinkOAuth(requestParameters.unlinkOAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unlink external wallet.
     * @param {AuthenticationApiUnlinkSIWERequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    unlinkSIWE(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).unlinkSIWE(requestParameters.sIWERequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verify a player\'s email address.
     * @summary Verify an email.
     * @param {AuthenticationApiVerifyEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    verifyEmail(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).verifyEmail(requestParameters.verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
     * @summary Retrieve player by token.
     * @param {AuthenticationApiVerifyOAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    verifyOAuth(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).verifyOAuth(requestParameters.provider, requestParameters.oAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The endpoint verifies the token generated by OAuth provider and retrieves a corresponding player.  Returns the latest 10 transaction intents for the player.
     * @summary Retrieve player by oauth token.
     * @param {AuthenticationApiVerifyOAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    verifyOAuthToken(requestParameters, options) {
        return AuthenticationApiFp(this.configuration).verifyOAuthToken(requestParameters.authenticateOAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SessionsApi - axios parameter creator
 * @export
 */
const SessionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a Session.
         * @summary Create a session key.
         * @param {CreateSessionRequest} createSessionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession: async (createSessionRequest, options = {}) => {
            // verify required parameter 'createSessionRequest' is not null or undefined
            assertParamExists('createSession', 'createSessionRequest', createSessionRequest);
            const localVarPath = `/v1/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of Sessions.  Returns the latest 10 transaction intents for each session.
         * @summary List session keys of a player.
         * @param {string} player The player ID (starts with pla_)
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<SessionResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerSessions: async (player, limit, skip, order, expand, options = {}) => {
            // verify required parameter 'player' is not null or undefined
            assertParamExists('getPlayerSessions', 'player', player);
            const localVarPath = `/v1/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (player !== undefined) {
                localVarQueryParameter['player'] = player;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a Session that has previously been created.  Returns the latest 10 transaction intents that used this session.
         * @summary Returns a player session by session id
         * @param {string} id Specifies the unique session ID (starts with ses_).
         * @param {Array<SessionResponseExpandable>} [expand] Specifies the fields to expand.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (id, expand, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSession', 'id', id);
            const localVarPath = `/v1/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke the session session key.
         * @param {RevokeSessionRequest} revokeSessionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSession: async (revokeSessionRequest, options = {}) => {
            // verify required parameter 'revokeSessionRequest' is not null or undefined
            assertParamExists('revokeSession', 'revokeSessionRequest', revokeSessionRequest);
            const localVarPath = `/v1/sessions/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(revokeSessionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send signed userOperationHash to create session.
         * @param {string} id Specifies the unique session ID (starts with ses_).
         * @param {SignatureRequest} signatureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signatureSession: async (id, signatureRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('signatureSession', 'id', id);
            // verify required parameter 'signatureRequest' is not null or undefined
            assertParamExists('signatureSession', 'signatureRequest', signatureRequest);
            const localVarPath = `/v1/sessions/{id}/signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(signatureRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SessionsApi - functional programming interface
 * @export
 */
const SessionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a Session.
         * @summary Create a session key.
         * @param {CreateSessionRequest} createSessionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSession(createSessionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSession(createSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of Sessions.  Returns the latest 10 transaction intents for each session.
         * @summary List session keys of a player.
         * @param {string} player The player ID (starts with pla_)
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<SessionResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerSessions(player, limit, skip, order, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerSessions(player, limit, skip, order, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of a Session that has previously been created.  Returns the latest 10 transaction intents that used this session.
         * @summary Returns a player session by session id
         * @param {string} id Specifies the unique session ID (starts with ses_).
         * @param {Array<SessionResponseExpandable>} [expand] Specifies the fields to expand.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(id, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(id, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Revoke the session session key.
         * @param {RevokeSessionRequest} revokeSessionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSession(revokeSessionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSession(revokeSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send signed userOperationHash to create session.
         * @param {string} id Specifies the unique session ID (starts with ses_).
         * @param {SignatureRequest} signatureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signatureSession(id, signatureRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signatureSession(id, signatureRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
class SessionsApi extends BaseAPI {
    /**
     * Creates a Session.
     * @summary Create a session key.
     * @param {SessionsApiCreateSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    createSession(requestParameters, options) {
        return SessionsApiFp(this.configuration).createSession(requestParameters.createSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of Sessions.  Returns the latest 10 transaction intents for each session.
     * @summary List session keys of a player.
     * @param {SessionsApiGetPlayerSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    getPlayerSessions(requestParameters, options) {
        return SessionsApiFp(this.configuration).getPlayerSessions(requestParameters.player, requestParameters.limit, requestParameters.skip, requestParameters.order, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the details of a Session that has previously been created.  Returns the latest 10 transaction intents that used this session.
     * @summary Returns a player session by session id
     * @param {SessionsApiGetSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    getSession(requestParameters, options) {
        return SessionsApiFp(this.configuration).getSession(requestParameters.id, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke the session session key.
     * @param {SessionsApiRevokeSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    revokeSession(requestParameters, options) {
        return SessionsApiFp(this.configuration).revokeSession(requestParameters.revokeSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send signed userOperationHash to create session.
     * @param {SessionsApiSignatureSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    signatureSession(requestParameters, options) {
        return SessionsApiFp(this.configuration).signatureSession(requestParameters.id, requestParameters.signatureRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * TransactionIntentsApi - axios parameter creator
 * @export
 */
const TransactionIntentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a TransactionIntent.  A pending TransactionIntent has the `response` attribute as undefined.  After the TransactionIntent is created and broadcasted to the blockchain, `response` will be populated with the transaction hash and a status (1 success, 0 fail).  When using a non-custodial account, a `nextAction` attribute is returned with the `userOperationHash` that must be signed by the owner of the account.
         * @summary Create a transaction intent object.
         * @param {CreateTransactionIntentRequest} createTransactionIntentRequest
         * @param {string} [xBehalfOfProject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransactionIntent: async (createTransactionIntentRequest, xBehalfOfProject, options = {}) => {
            // verify required parameter 'createTransactionIntentRequest' is not null or undefined
            assertParamExists('createTransactionIntent', 'createTransactionIntentRequest', createTransactionIntentRequest);
            const localVarPath = `/v1/transaction_intents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xBehalfOfProject != null) {
                localVarHeaderParameter['X-Behalf-Of-Project'] = String(xBehalfOfProject);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionIntentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Estimate the gas cost of broadcasting a TransactionIntent.  This is a simulation, it does not send the transaction on-chain.  If a Policy ID is used that includes payment of gas in ERC-20 tokens, an extra field `estimatedTXGasFeeToken` is returned with the estimated amount of tokens that will be used.
         * @summary Estimate gas cost of creating a transaction
         * @param {CreateTransactionIntentRequest} createTransactionIntentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateTransactionIntentCost: async (createTransactionIntentRequest, options = {}) => {
            // verify required parameter 'createTransactionIntentRequest' is not null or undefined
            assertParamExists('estimateTransactionIntentCost', 'createTransactionIntentRequest', createTransactionIntentRequest);
            const localVarPath = `/v1/transaction_intents/estimate_gas_cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createTransactionIntentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a TransactionIntent that has previously been created.
         * @summary Get a transaction intent object.
         * @param {string} id Specifies the unique transaction intent ID (starts with tin_).
         * @param {Array<TransactionIntentResponseExpandable>} [expand] Specifies the expandable fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionIntent: async (id, expand, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransactionIntent', 'id', id);
            const localVarPath = `/v1/transaction_intents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of TransactionIntents.
         * @summary List transaction intents.
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<TransactionIntentResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {number} [chainId] The chain ID. Must be a [supported chain](/chains).
         * @param {Array<string>} [account] Filter by account ID or developer account (starts with acc_ or dac_ respectively).
         * @param {Array<string>} [player] Filter by player ID (starts with pla_).
         * @param {number} [status] Filter by successful (1) or failed (0) transaction intents.
         * @param {Array<string>} [policy] Filter by policy ID (starts with pol_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionIntents: async (limit, skip, order, expand, chainId, account, player, status, policy, options = {}) => {
            const localVarPath = `/v1/transaction_intents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }
            if (chainId !== undefined) {
                localVarQueryParameter['chainId'] = chainId;
            }
            if (account) {
                localVarQueryParameter['account'] = account;
            }
            if (player) {
                localVarQueryParameter['player'] = player;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (policy) {
                localVarQueryParameter['policy'] = policy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Broadcasts a signed TransactionIntent to the blockchain.  Use this endpoint to send the signed `userOperationHash`. Openfort will then put it on-chain.
         * @summary Send a signed transaction userOperationHash.
         * @param {string} id Specifies the unique transaction intent ID (starts with tin_).
         * @param {SignatureRequest} signatureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signature: async (id, signatureRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('signature', 'id', id);
            // verify required parameter 'signatureRequest' is not null or undefined
            assertParamExists('signature', 'signatureRequest', signatureRequest);
            const localVarPath = `/v1/transaction_intents/{id}/signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication sk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication pk required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(signatureRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TransactionIntentsApi - functional programming interface
 * @export
 */
const TransactionIntentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TransactionIntentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a TransactionIntent.  A pending TransactionIntent has the `response` attribute as undefined.  After the TransactionIntent is created and broadcasted to the blockchain, `response` will be populated with the transaction hash and a status (1 success, 0 fail).  When using a non-custodial account, a `nextAction` attribute is returned with the `userOperationHash` that must be signed by the owner of the account.
         * @summary Create a transaction intent object.
         * @param {CreateTransactionIntentRequest} createTransactionIntentRequest
         * @param {string} [xBehalfOfProject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransactionIntent(createTransactionIntentRequest, xBehalfOfProject, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransactionIntent(createTransactionIntentRequest, xBehalfOfProject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Estimate the gas cost of broadcasting a TransactionIntent.  This is a simulation, it does not send the transaction on-chain.  If a Policy ID is used that includes payment of gas in ERC-20 tokens, an extra field `estimatedTXGasFeeToken` is returned with the estimated amount of tokens that will be used.
         * @summary Estimate gas cost of creating a transaction
         * @param {CreateTransactionIntentRequest} createTransactionIntentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimateTransactionIntentCost(createTransactionIntentRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimateTransactionIntentCost(createTransactionIntentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of a TransactionIntent that has previously been created.
         * @summary Get a transaction intent object.
         * @param {string} id Specifies the unique transaction intent ID (starts with tin_).
         * @param {Array<TransactionIntentResponseExpandable>} [expand] Specifies the expandable fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionIntent(id, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionIntent(id, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of TransactionIntents.
         * @summary List transaction intents.
         * @param {number} [limit] Specifies the maximum number of records to return.
         * @param {number} [skip] Specifies the offset for the first records to return.
         * @param {SortOrder} [order] Specifies the order in which to sort the results.
         * @param {Array<TransactionIntentResponseExpandable>} [expand] Specifies the fields to expand in the response.
         * @param {number} [chainId] The chain ID. Must be a [supported chain](/chains).
         * @param {Array<string>} [account] Filter by account ID or developer account (starts with acc_ or dac_ respectively).
         * @param {Array<string>} [player] Filter by player ID (starts with pla_).
         * @param {number} [status] Filter by successful (1) or failed (0) transaction intents.
         * @param {Array<string>} [policy] Filter by policy ID (starts with pol_).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionIntents(limit, skip, order, expand, chainId, account, player, status, policy, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionIntents(limit, skip, order, expand, chainId, account, player, status, policy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Broadcasts a signed TransactionIntent to the blockchain.  Use this endpoint to send the signed `userOperationHash`. Openfort will then put it on-chain.
         * @summary Send a signed transaction userOperationHash.
         * @param {string} id Specifies the unique transaction intent ID (starts with tin_).
         * @param {SignatureRequest} signatureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signature(id, signatureRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signature(id, signatureRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TransactionIntentsApi - object-oriented interface
 * @export
 * @class TransactionIntentsApi
 * @extends {BaseAPI}
 */
class TransactionIntentsApi extends BaseAPI {
    /**
     * Creates a TransactionIntent.  A pending TransactionIntent has the `response` attribute as undefined.  After the TransactionIntent is created and broadcasted to the blockchain, `response` will be populated with the transaction hash and a status (1 success, 0 fail).  When using a non-custodial account, a `nextAction` attribute is returned with the `userOperationHash` that must be signed by the owner of the account.
     * @summary Create a transaction intent object.
     * @param {TransactionIntentsApiCreateTransactionIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionIntentsApi
     */
    createTransactionIntent(requestParameters, options) {
        return TransactionIntentsApiFp(this.configuration).createTransactionIntent(requestParameters.createTransactionIntentRequest, requestParameters.xBehalfOfProject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Estimate the gas cost of broadcasting a TransactionIntent.  This is a simulation, it does not send the transaction on-chain.  If a Policy ID is used that includes payment of gas in ERC-20 tokens, an extra field `estimatedTXGasFeeToken` is returned with the estimated amount of tokens that will be used.
     * @summary Estimate gas cost of creating a transaction
     * @param {TransactionIntentsApiEstimateTransactionIntentCostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionIntentsApi
     */
    estimateTransactionIntentCost(requestParameters, options) {
        return TransactionIntentsApiFp(this.configuration).estimateTransactionIntentCost(requestParameters.createTransactionIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the details of a TransactionIntent that has previously been created.
     * @summary Get a transaction intent object.
     * @param {TransactionIntentsApiGetTransactionIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionIntentsApi
     */
    getTransactionIntent(requestParameters, options) {
        return TransactionIntentsApiFp(this.configuration).getTransactionIntent(requestParameters.id, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of TransactionIntents.
     * @summary List transaction intents.
     * @param {TransactionIntentsApiGetTransactionIntentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionIntentsApi
     */
    getTransactionIntents(requestParameters = {}, options) {
        return TransactionIntentsApiFp(this.configuration).getTransactionIntents(requestParameters.limit, requestParameters.skip, requestParameters.order, requestParameters.expand, requestParameters.chainId, requestParameters.account, requestParameters.player, requestParameters.status, requestParameters.policy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Broadcasts a signed TransactionIntent to the blockchain.  Use this endpoint to send the signed `userOperationHash`. Openfort will then put it on-chain.
     * @summary Send a signed transaction userOperationHash.
     * @param {TransactionIntentsApiSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionIntentsApi
     */
    signature(requestParameters, options) {
        return TransactionIntentsApiFp(this.configuration).signature(requestParameters.id, requestParameters.signatureRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * Openfort API
 * Complete Openfort API references and guides can be found at: https://openfort.xyz/docs
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: founders@openfort.xyz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class Configuration {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    apiKey;
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    username;
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    password;
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    accessToken;
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    basePath;
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    baseOptions;
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    formDataCtor;
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}

class BackendApiClients {
    config;
    transactionIntentsApi;
    accountsApi;
    sessionsApi;
    authenticationApi;
    constructor(config) {
        this.config = config;
        this.transactionIntentsApi = new TransactionIntentsApi(config.backend);
        this.accountsApi = new AccountsApi(config.backend);
        this.sessionsApi = new SessionsApi(config.backend);
        this.authenticationApi = new AuthenticationApi(config.backend);
    }
}

const createConfig = ({ basePath, accessToken, }) => {
    if (!basePath.trim()) {
        throw Error('basePath can not be empty');
    }
    const apiConfigOptions = {
        basePath,
        accessToken,
    };
    return new Configuration(apiConfigOptions);
};

var EmbeddedState;
(function (EmbeddedState) {
    EmbeddedState[EmbeddedState["NONE"] = 0] = "NONE";
    EmbeddedState[EmbeddedState["UNAUTHENTICATED"] = 1] = "UNAUTHENTICATED";
    EmbeddedState[EmbeddedState["EMBEDDED_SIGNER_NOT_CONFIGURED"] = 2] = "EMBEDDED_SIGNER_NOT_CONFIGURED";
    EmbeddedState[EmbeddedState["CREATING_ACCOUNT"] = 3] = "CREATING_ACCOUNT";
    EmbeddedState[EmbeddedState["READY"] = 4] = "READY";
})(EmbeddedState || (EmbeddedState = {}));
var OpenfortEvents;
(function (OpenfortEvents) {
    OpenfortEvents["LOGGED_OUT"] = "loggedOut";
})(OpenfortEvents || (OpenfortEvents = {}));
var AccountType;
(function (AccountType) {
    AccountType["UPGRADEABLE_V4"] = "Upgradeable_v04";
    AccountType["MANAGED_V4"] = "Managed_v04";
    AccountType["ERC6551_V4"] = "ERC6551_v04";
    AccountType["ERC6551_V5"] = "ERC6551_v05";
    AccountType["RECOVERABLE_V4"] = "Recoverable_v04";
    AccountType["MANAGED_V5"] = "Managed_v05";
    AccountType["UPGRADEABLE_V5"] = "Upgradeable_v05";
})(AccountType || (AccountType = {}));
var AuthType;
(function (AuthType) {
    AuthType["OPENFORT"] = "openfort";
    AuthType["THIRD_PARTY"] = "thirdParty";
})(AuthType || (AuthType = {}));
var TokenType;
(function (TokenType) {
    TokenType["ID_TOKEN"] = "idToken";
    TokenType["CUSTOM_TOKEN"] = "customToken";
})(TokenType || (TokenType = {}));
var ThirdPartyOAuthProvider;
(function (ThirdPartyOAuthProvider) {
    ThirdPartyOAuthProvider["ACCELBYTE"] = "accelbyte";
    ThirdPartyOAuthProvider["FIREBASE"] = "firebase";
    ThirdPartyOAuthProvider["LOOTLOCKER"] = "lootlocker";
    ThirdPartyOAuthProvider["PLAYFAB"] = "playfab";
    ThirdPartyOAuthProvider["SUPABASE"] = "supabase";
    ThirdPartyOAuthProvider["CUSTOM"] = "custom";
    ThirdPartyOAuthProvider["OIDC"] = "oidc";
})(ThirdPartyOAuthProvider || (ThirdPartyOAuthProvider = {}));
var BasicAuthProvider;
(function (BasicAuthProvider) {
    BasicAuthProvider["EMAIL"] = "email";
    BasicAuthProvider["WALLET"] = "wallet";
})(BasicAuthProvider || (BasicAuthProvider = {}));
var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["GOOGLE"] = "google";
    OAuthProvider["TWITTER"] = "twitter";
    OAuthProvider["FACEBOOK"] = "facebook";
    OAuthProvider["DISCORD"] = "discord";
    OAuthProvider["EPIC_GAMES"] = "epic_games";
})(OAuthProvider || (OAuthProvider = {}));
var CodeChallengeMethodEnum;
(function (CodeChallengeMethodEnum) {
    CodeChallengeMethodEnum["PLAIN"] = "plain";
    CodeChallengeMethodEnum["S256"] = "S256";
})(CodeChallengeMethodEnum || (CodeChallengeMethodEnum = {}));

class OpenfortConfiguration {
    publishableKey;
    constructor(options) {
        this.publishableKey = options.publishableKey;
    }
}
class ShieldConfiguration {
    shieldPublishableKey;
    shieldEncryptionKey;
    debug = false;
    constructor(options) {
        this.shieldPublishableKey = options.shieldPublishableKey;
        this.shieldEncryptionKey = options.shieldEncryptionKey;
        this.debug = options.shieldDebug || false;
    }
}
class SDKConfiguration {
    baseConfiguration;
    shieldConfiguration;
    shieldUrl;
    iframeUrl;
    backendUrl;
    openfortAPIConfig;
    constructor({ baseConfiguration, shieldConfiguration, overrides, }) {
        this.shieldConfiguration = shieldConfiguration;
        this.baseConfiguration = baseConfiguration;
        if (overrides) {
            this.backendUrl = overrides.backendUrl || 'https://api.openfort.xyz';
            this.iframeUrl = overrides.iframeUrl || 'https://iframe.openfort.xyz';
            this.shieldUrl = overrides.shieldUrl || 'https://shield.openfort.xyz';
            this.openfortAPIConfig = {
                backend: createConfig({
                    basePath: overrides.backendUrl || 'https://api.openfort.xyz',
                    accessToken: baseConfiguration.publishableKey,
                }),
            };
        }
        else {
            this.backendUrl = 'https://api.openfort.xyz';
            this.iframeUrl = 'https://iframe.openfort.xyz';
            this.shieldUrl = 'https://shield.openfort.xyz';
            this.openfortAPIConfig = {
                backend: createConfig({
                    basePath: 'https://api.openfort.xyz',
                    accessToken: baseConfiguration.publishableKey,
                }),
            };
        }
    }
}

const chain$o = {
    chain: 'BSC',
    chainId: 56,
    explorers: [
        {
            name: 'bscscan',
            url: 'https://bscscan.com',
            standard: 'EIP3091',
        },
        {
            name: 'dexguru',
            url: 'https://bnb.dex.guru',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne',
                width: 83,
                height: 82,
                format: 'svg',
            },
        },
    ],
    faucets: [],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/binance-coin/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://www.bnbchain.org/en',
    name: 'BNB Smart Chain Mainnet',
    nativeCurrency: {
        name: 'BNB Chain Native Token',
        symbol: 'BNB',
        decimals: 18,
    },
    networkId: 56,
    redFlags: [],
    rpc: [
        'https://bsc.publicnode.com',
        'https://bsc-dataseed1.bnbchain.org',
        'https://bsc-dataseed2.bnbchain.org',
        'https://bsc-dataseed3.bnbchain.org',
        'https://bsc-dataseed4.bnbchain.org',
        'https://bsc-dataseed1.defibit.io',
        'https://bsc-dataseed2.defibit.io',
        'https://bsc-dataseed3.defibit.io',
        'https://bsc-dataseed4.defibit.io',
        'https://bsc-dataseed1.ninicoin.io',
        'https://bsc-dataseed2.ninicoin.io',
        'https://bsc-dataseed3.ninicoin.io',
        'https://bsc-dataseed4.ninicoin.io',
        'wss://bsc.publicnode.com',
        'wss://bsc-ws-node.nariox.org',
    ],
    shortName: 'bnb',
    slip44: 714,
    slug: 'binance',
    testnet: false,
};

const chain$n = {
    chain: 'BSC',
    chainId: 97,
    explorers: [
        {
            name: 'bscscan-testnet',
            url: 'https://testnet.bscscan.com',
            standard: 'EIP3091',
        },
    ],
    faucets: ['https://testnet.bnbchain.org/faucet-smart'],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/binance-coin/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://www.bnbchain.org/en',
    name: 'BNB Smart Chain Testnet',
    nativeCurrency: {
        name: 'BNB Chain Native Token',
        symbol: 'tBNB',
        decimals: 18,
    },
    networkId: 97,
    redFlags: [],
    rpc: [
        'https://bsc-testnet.publicnode.com',
        'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
        'https://data-seed-prebsc-2-s1.bnbchain.org:8545',
        'https://data-seed-prebsc-1-s2.bnbchain.org:8545',
        'https://data-seed-prebsc-2-s2.bnbchain.org:8545',
        'https://data-seed-prebsc-1-s3.bnbchain.org:8545',
        'https://data-seed-prebsc-2-s3.bnbchain.org:8545',
    ],
    shortName: 'bnbt',
    slug: 'binance-testnet',
    testnet: true,
};

const chain$m = {
    name: 'Base',
    chain: 'ETH',
    rpc: [
        'https://mainnet.base.org',
    ],
    faucets: [],
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    infoURL: 'https://base.org',
    shortName: 'base',
    chainId: 8453,
    networkId: 8453,
    icon: {
        url: 'ipfs://QmW5Vn15HeRkScMfPcW12ZdZcC2yUASpu6eCsECRdEmjjj/base-512.png',
        height: 512,
        width: 512,
        format: 'png',
    },
    explorers: [
        {
            name: 'basescout',
            url: 'https://base.blockscout.com',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
            standard: 'EIP3091',
        },
        {
            name: 'basescan',
            url: 'https://basescan.org',
            standard: 'none',
        },
    ],
    status: 'active',
    testnet: false,
    slug: 'base',
};

const chain$l = {
    chain: 'ETH',
    chainId: 84532,
    explorers: [
        {
            name: 'basescout',
            url: 'https://base-sepolia.blockscout.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
        },
    ],
    faucets: [],
    icon: {
        url: 'ipfs://QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv',
        width: 1200,
        height: 1200,
        format: 'png',
    },
    infoURL: 'https://base.org',
    name: 'Base Sepolia Testnet',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 84532,
    rpc: [
        'https://sepolia.base.org',
    ],
    shortName: 'basesep',
    slug: 'base-sepolia-testnet',
    testnet: true,
};

const chain$k = {
    name: 'Beam',
    chainId: 4337,
    chain: 'BEAM',
    shortName: 'Beam',
    slug: 'beam',
    icon: {
        url: 'ipfs://QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt',
        height: 512,
        width: 512,
        format: 'png',
    },
    features: [
        {
            name: 'EIP1559',
        },
    ],
    nativeCurrency: {
        name: 'Beam',
        symbol: 'BEAM',
        decimals: 18,
    },
    rpc: [
        'https://build.onbeam.com/rpc',
    ],
    faucets: ['https://faucet.onbeam.com'],
    explorers: [
        {
            name: 'Beam Explorer',
            url: 'https://subnets.avax.network/beam/',
            standard: 'EIP3091',
        },
    ],
    infoURL: 'https://gaming.meritcircle.io/',
    testnet: false,
};

const chain$j = {
    name: 'Beam Testnet',
    chainId: 13337,
    chain: 'BEAM',
    shortName: 'Beam Testnet',
    slug: 'beam-testnet',
    features: [
        {
            name: 'EIP1559',
        },
    ],
    icon: {
        url: 'ipfs://QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt',
        height: 512,
        width: 512,
        format: 'png',
    },
    nativeCurrency: {
        name: 'Beam',
        symbol: 'BEAM',
        decimals: 18,
    },
    rpc: [
        'https://build.onbeam.com/rpc/testnet',
    ],
    faucets: ['https://faucet.avax.network/?subnet=beam', 'https://faucet.onbeam.com'],
    explorers: [
        {
            name: 'Beam Explorer',
            url: 'https://subnets-test.avax.network/beam',
            standard: 'EIP3091',
        },
    ],
    infoURL: 'https://www.onbeam.com',
    testnet: true,
};

const chain$i = {
    chain: 'AVAX',
    chainId: 43113,
    explorers: [
        {
            name: 'snowtrace',
            url: 'https://testnet.snowtrace.io',
            standard: 'EIP3091',
        },
    ],
    faucets: ['https://faucet.avax-test.network/'],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/avalanche/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://cchain.explorer.avax-test.network',
    name: 'Avalanche Fuji Testnet',
    nativeCurrency: {
        name: 'Avalanche',
        symbol: 'AVAX',
        decimals: 18,
    },
    networkId: 43113,
    redFlags: [],
    rpc: [
        'https://api.avax-test.network/ext/bc/C/rpc',
        'https://avalanche-fuji-c-chain.publicnode.com',
    ],
    shortName: 'Fuji',
    slug: 'avalanche-fuji',
    testnet: true,
};

const chain$h = {
    chain: 'AVAX',
    chainId: 43114,
    explorers: [
        {
            name: 'snowtrace',
            url: 'https://snowtrace.io',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    features: [
        {
            name: 'EIP1559',
        },
    ],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/avalanche/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://www.avax.network/',
    name: 'Avalanche C-Chain',
    nativeCurrency: {
        name: 'Avalanche',
        symbol: 'AVAX',
        decimals: 18,
    },
    networkId: 43114,
    redFlags: [],
    rpc: [
        'https://api.avax.network/ext/bc/C/rpc',
        'https://avalanche-c-chain.publicnode.com',
    ],
    shortName: 'avax',
    slip44: 9005,
    slug: 'avalanche',
    testnet: false,
};

const chain$g = {
    chain: 'ETH',
    chainId: 11155111,
    explorers: [
        {
            name: 'etherscan-sepolia',
            url: 'https://sepolia.etherscan.io',
            standard: 'EIP3091',
        },
        {
            name: 'otterscan-sepolia',
            url: 'https://sepolia.otterscan.io',
            standard: 'EIP3091',
        },
    ],
    faucets: ['http://fauceth.komputing.org?chain=11155111'],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/ethereum/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://sepolia.otterscan.io',
    name: 'Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 11155111,
    redFlags: [],
    rpc: [
        'https://rpc.sepolia.org',
        'https://rpc2.sepolia.org',
        'https://rpc-sepolia.rockx.com',
        'https://rpc.sepolia.ethpandaops.io',
        'https://sepolia.gateway.tenderly.co',
        'https://ethereum-sepolia.publicnode.com',
    ],
    shortName: 'sep',
    slug: 'sepolia',
    testnet: true,
    title: 'Ethereum Testnet Sepolia',
};

const chain$f = {
    chain: 'ETH',
    chainId: 59140,
    explorers: [
        {
            name: 'Etherscan',
            url: 'https://goerli.lineascan.build',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH',
                width: 97,
                height: 102,
                format: 'svg',
            },
        },
        {
            name: 'Blockscout',
            url: 'https://explorer.goerli.linea.build',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH',
                width: 97,
                height: 102,
                format: 'svg',
            },
        },
    ],
    faucets: ['https://faucetlink.to/goerli'],
    icon: {
        url: 'ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH',
        width: 97,
        height: 102,
        format: 'svg',
    },
    infoURL: 'https://linea.build',
    name: 'Linea Testnet',
    nativeCurrency: {
        name: 'Linea Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 59140,
    parent: {
        type: 'L2',
        chain: 'eip155-5',
        bridges: [
            {
                url: 'https://goerli.hop.exchange/#/send?token=ETH&sourceNetwork=ethereum&destNetwork=linea',
            },
        ],
    },
    rpc: [
        'https://rpc.goerli.linea.build',
        'wss://rpc.goerli.linea.build',
    ],
    shortName: 'linea-testnet',
    slug: 'linea-testnet',
    status: 'active',
    testnet: true,
    title: 'Linea Goerli Testnet',
};

const chain$e = {
    chain: 'GNO',
    chainId: 10200,
    explorers: [
        {
            name: 'blockscout',
            url: 'https://gnosis-chiado.blockscout.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
        },
    ],
    faucets: ['https://gnosisfaucet.com'],
    icon: {
        url: 'ipfs://bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm',
        width: 1800,
        height: 1800,
        format: 'png',
    },
    infoURL: 'https://docs.gnosischain.com',
    name: 'Gnosis Chiado Testnet',
    nativeCurrency: {
        name: 'Chiado xDAI',
        symbol: 'XDAI',
        decimals: 18,
    },
    networkId: 10200,
    rpc: [
        'https://rpc.chiadochain.net',
        'https://rpc.chiado.gnosis.gateway.fm',
        'wss://rpc.chiadochain.net/wss',
        'https://gnosis-chiado-rpc.publicnode.com',
        'wss://gnosis-chiado-rpc.publicnode.com',
        'https://gnosis-chiado.drpc.org',
        'wss://gnosis-chiado.drpc.org',
    ],
    shortName: 'chi',
    slip44: 1,
    slug: 'gnosis-chiado-testnet',
    testnet: true,
};

const chain$d = {
    chain: 'Immutable zkEVM',
    chainId: 13371,
    explorers: [
        {
            name: 'Immutable explorer',
            url: 'https://explorer.immutable.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw',
                width: 1168,
                height: 1168,
                format: 'png',
            },
        },
    ],
    faucets: ['https://docs.immutable.com/docs/zkEVM/guides/faucet'],
    icon: {
        url: 'ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw',
        width: 1168,
        height: 1168,
        format: 'png',
    },
    infoURL: 'https://www.immutable.com',
    name: 'Immutable zkEVM',
    nativeCurrency: {
        name: 'IMX',
        symbol: 'IMX',
        decimals: 18,
    },
    networkId: 13371,
    rpc: [
        'https://rpc.immutable.com',
        'https://immutable-zkevm.drpc.org',
        'wss://immutable-zkevm.drpc.org',
    ],
    shortName: 'imx',
    slug: 'immutable-zkevm',
    testnet: false,
};

const chain$c = {
    chain: 'ETH',
    chainId: 421614,
    explorers: [
        {
            name: 'Arbitrum Sepolia Rollup Testnet Explorer',
            url: 'https://sepolia-explorer.arbitrum.io',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    infoURL: 'https://arbitrum.io',
    name: 'Arbitrum Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 421614,
    parent: {
        type: 'L2',
        chain: 'eip155-11155111',
        bridges: [
            {
                url: 'https://bridge.arbitrum.io',
            },
        ],
    },
    rpc: [
        'https://sepolia-rollup.arbitrum.io/rpc',
    ],
    shortName: 'arb-sep',
    slug: 'arbitrum-sepolia',
    testnet: true,
    title: 'Arbitrum Sepolia Rollup Testnet',
};

const chain$b = {
    chain: 'ETH',
    chainId: 42161,
    explorers: [
        {
            name: 'Arbiscan',
            url: 'https://arbiscan.io',
            standard: 'EIP3091',
        },
        {
            name: 'Arbitrum Explorer',
            url: 'https://explorer.arbitrum.io',
            standard: 'EIP3091',
        },
        {
            name: 'dexguru',
            url: 'https://arbitrum.dex.guru',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne',
                width: 83,
                height: 82,
                format: 'svg',
            },
        },
    ],
    faucets: [],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/arbitrum/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://arbitrum.io',
    name: 'Arbitrum One',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 42161,
    parent: {
        type: 'L2',
        chain: 'eip155-1',
        bridges: [
            {
                url: 'https://bridge.arbitrum.io',
            },
        ],
    },
    redFlags: [],
    rpc: [
        'https://arb1.arbitrum.io/rpc',
        'https://arbitrum-one.publicnode.com',
        'wss://arbitrum-one.publicnode.com',
    ],
    shortName: 'arb1',
    slug: 'arbitrum',
    testnet: false,
};

const chain$a = {
    chain: 'ETH',
    chainId: 42170,
    explorers: [
        {
            name: 'Arbitrum Nova Chain Explorer',
            url: 'https://nova-explorer.arbitrum.io',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
        },
        {
            name: 'dexguru',
            url: 'https://nova.dex.guru',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne',
                width: 83,
                height: 82,
                format: 'svg',
            },
        },
    ],
    faucets: [],
    infoURL: 'https://arbitrum.io',
    name: 'Arbitrum Nova',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 42170,
    parent: {
        type: 'L2',
        chain: 'eip155-1',
        bridges: [
            {
                url: 'https://bridge.arbitrum.io',
            },
        ],
    },
    rpc: [
        'https://nova.arbitrum.io/rpc',
        'https://arbitrum-nova.publicnode.com',
        'wss://arbitrum-nova.publicnode.com',
    ],
    shortName: 'arb-nova',
    slug: 'arbitrum-nova',
    testnet: false,
};

const chain$9 = {
    chain: 'Polygon',
    chainId: 137,
    explorers: [
        {
            name: 'polygonscan',
            url: 'https://polygonscan.com',
            standard: 'EIP3091',
        },
        {
            name: 'dexguru',
            url: 'https://polygon.dex.guru',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne',
                width: 83,
                height: 82,
                format: 'svg',
            },
        },
    ],
    faucets: [],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/polygon/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://polygon.technology/',
    name: 'Polygon Mainnet',
    nativeCurrency: {
        name: 'MATIC',
        symbol: 'MATIC',
        decimals: 18,
    },
    networkId: 137,
    redFlags: [],
    rpc: [
        'https://polygon-rpc.com',
        'https://rpc-mainnet.matic.network',
        'https://matic-mainnet.chainstacklabs.com',
        'https://rpc-mainnet.maticvigil.com',
        'https://rpc-mainnet.matic.quiknode.pro',
        'https://matic-mainnet-full-rpc.bwarelabs.com',
        'https://polygon-bor.publicnode.com',
        'wss://polygon-bor.publicnode.com',
        'https://polygon.gateway.tenderly.co',
        'wss://polygon.gateway.tenderly.co',
    ],
    shortName: 'matic',
    slip44: 966,
    slug: 'polygon',
    testnet: false,
};

const chain$8 = {
    chain: 'Polygon',
    chainId: 80002,
    explorers: [
        {
            name: 'polygonamoy',
            url: 'https://www.oklink.com/amoy',
            standard: 'EIP3091',
        },
    ],
    faucets: ['https://faucet.polygon.technology/'],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/polygon/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://polygon.technology/',
    name: 'Polygon Amoy Testnet',
    nativeCurrency: {
        name: 'MATIC',
        symbol: 'MATIC',
        decimals: 18,
    },
    networkId: 80002,
    redFlags: [],
    rpc: [
        'https://rpc-amoy.polygon.technology',
    ],
    shortName: 'polygonamoy',
    slip44: 1,
    slug: 'polygon-amoy-testnet',
    testnet: true,
    title: 'Polygon Amoy Testnet',
};

const chain$7 = {
    chain: 'Ancient8',
    chainId: 28122024,
    explorers: [
        {
            name: 'scan-testnet',
            url: 'https://scanv2-testnet.ancient8.gg',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    icon: {
        url: 'ipfs://bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym',
        width: 128,
        height: 128,
        format: 'png',
    },
    infoURL: 'https://ancient8.gg/',
    name: 'Ancient8 Testnet',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 28122024,
    rpc: ['https://rpcv2-testnet.ancient8.gg'],
    shortName: 'a8',
    slip44: 1,
    slug: 'ancient8-testnet',
    testnet: true,
};

const chain$6 = {
    chain: 'Ancient8',
    chainId: 888888888,
    explorers: [
        {
            name: 'Ancient8 Explorer',
            url: 'https://scan.ancient8.gg',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    icon: {
        url: 'ipfs://bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym',
        width: 128,
        height: 128,
        format: 'png',
    },
    infoURL: 'https://ancient8.gg/',
    name: 'Ancient8',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 888888888,
    rpc: ['https://rpc.ancient8.gg'],
    shortName: 'ancient8',
    slug: 'ancient8',
    testnet: false,
};

const chain$5 = {
    chain: 'ETH',
    chainId: 999999999,
    explorers: [
        {
            name: 'Zora Sepolia Testnet Network Explorer',
            url: 'https://sepolia.explorer.zora.energy',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    icon: {
        url: 'ipfs://bafkreifvrly5tgd34xqeo67s4etmiu52bkroml7uy7eosizf57htf5nrzq',
        width: 250,
        height: 250,
        format: 'png',
    },
    infoURL: 'https://zora.energy',
    name: 'Zora Sepolia Testnet',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 999999999,
    rpc: ['https://sepolia.rpc.zora.energy'],
    shortName: 'zsep',
    slip44: 1,
    slug: 'zora-sepolia-testnet',
    testnet: true,
};

const chain$4 = {
    chain: 'ETH',
    chainId: 7777777,
    explorers: [
        {
            name: 'Zora Network Explorer',
            url: 'https://explorer.zora.energy',
            standard: 'EIP3091',
        },
    ],
    faucets: [],
    features: [],
    icon: {
        url: 'ipfs://QmZ6qaRwTPFEZUspwMUjaxC6KhmzcELdRQcQzS3P72Dzts/Vector.svg',
        width: 512,
        height: 512,
        format: 'svg',
    },
    infoURL: 'https://zora.energy',
    name: 'Zora',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 7777777,
    redFlags: [],
    rpc: ['https://rpc.zora.energy/'],
    shortName: 'zora',
    slug: 'zora',
    testnet: false,
};

const chain$3 = {
    chain: 'Degen',
    chainId: 666666666,
    explorers: [],
    faucets: [],
    icon: {
        url: 'ipfs://Qmb6yAe4wXeBkxjfhxzoUT9TzETcmE7Vne59etm9GJaQf7',
        width: 789,
        height: 668,
        format: 'svg',
    },
    infoURL: 'https://degen.tips',
    name: 'Degen Chain',
    nativeCurrency: {
        name: 'DEGEN',
        symbol: 'DEGEN',
        decimals: 18,
    },
    networkId: 666666666,
    rpc: ['https://rpc.degen.tips'],
    shortName: 'degen-chain',
    slug: 'degen-chain',
    status: 'incubating',
    testnet: false,
    title: 'Degen Chain',
};

const chain$2 = {
    chain: 'Immutable zkEVM',
    chainId: 13473,
    explorers: [
        {
            name: 'Immutable Testnet explorer',
            url: 'https://explorer.testnet.immutable.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw',
                width: 1168,
                height: 1168,
                format: 'png',
            },
        },
    ],
    faucets: ['https://docs.immutable.com/docs/zkEVM/guides/faucet'],
    icon: {
        url: 'ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw',
        width: 1168,
        height: 1168,
        format: 'png',
    },
    infoURL: 'https://www.immutable.com',
    name: 'Immutable zkEVM Testnet',
    nativeCurrency: {
        name: 'Test IMX',
        symbol: 'tIMX',
        decimals: 18,
    },
    networkId: 13473,
    rpc: [
        'https://rpc.testnet.immutable.com',
        'https://immutable-zkevm-testnet.drpc.org',
        'wss://immutable-zkevm-testnet.drpc.org',
    ],
    shortName: 'imx-testnet',
    slip44: 1,
    slug: 'immutable-zkevm-testnet',
    testnet: true,
};

const chain$1 = {
    chain: 'ETH',
    chainId: 11155420,
    explorers: [
        {
            name: 'etherscan',
            url: 'https://sepolia-optimism.etherscan.io',
            standard: 'EIP3091',
        },
        {
            name: 'opscout',
            url: 'https://optimism-sepolia.blockscout.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
        },
    ],
    faucets: ['https://app.optimism.io/faucet'],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/optimism/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://optimism.io',
    name: 'OP Sepolia Testnet',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 11155420,
    redFlags: [],
    rpc: [
        'https://optimism-sepolia-rpc.publicnode.com',
    ],
    shortName: 'opsep',
    slip44: 1,
    slug: 'op-sepolia-testnet',
    testnet: true,
};

const chain = {
    chain: 'ETH',
    chainId: 10,
    explorers: [
        {
            name: 'etherscan',
            url: 'https://optimistic.etherscan.io',
            standard: 'EIP3091',
        },
        {
            name: 'blockscout',
            url: 'https://optimism.blockscout.com',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM',
                width: 551,
                height: 540,
                format: 'png',
            },
        },
        {
            name: 'dexguru',
            url: 'https://optimism.dex.guru',
            standard: 'EIP3091',
            icon: {
                url: 'ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne',
                width: 83,
                height: 82,
                format: 'svg',
            },
        },
    ],
    faucets: [],
    features: [],
    icon: {
        url: 'ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/optimism/512.png',
        width: 512,
        height: 512,
        format: 'png',
    },
    infoURL: 'https://optimism.io',
    name: 'OP Mainnet',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    networkId: 10,
    redFlags: [],
    rpc: [
        'https://optimism-rpc.publicnode.com',
    ],
    shortName: 'oeth',
    slug: 'optimism',
    testnet: false,
};

const chainMap = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    56: chain$o,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    97: chain$n,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    8453: chain$m,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    84532: chain$l,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    4337: chain$k,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    13337: chain$j,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    43113: chain$i,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    43114: chain$h,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    11155111: chain$g,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    59140: chain$f,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    10200: chain$e,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    421614: chain$c,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    42161: chain$b,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    42170: chain$a,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    137: chain$9,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    80002: chain$8,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    28122024: chain$7,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    888888888: chain$6,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    999999999: chain$5,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    7777777: chain$4,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    666666666: chain$3,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    13473: chain$2,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    13371: chain$d,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    11155420: chain$1,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    10: chain,
};

var BackendTransactionStatus;
(function (BackendTransactionStatus) {
    BackendTransactionStatus["PENDING"] = "PENDING";
    BackendTransactionStatus["SUBMITTED"] = "SUBMITTED";
    BackendTransactionStatus["SUCCESSFUL"] = "SUCCESSFUL";
    BackendTransactionStatus["REVERTED"] = "REVERTED";
    BackendTransactionStatus["FAILED"] = "FAILED";
    BackendTransactionStatus["CANCELLED"] = "CANCELLED";
})(BackendTransactionStatus || (BackendTransactionStatus = {}));
var ProviderEvent;
(function (ProviderEvent) {
    ProviderEvent["ACCOUNTS_CHANGED"] = "accountsChanged";
})(ProviderEvent || (ProviderEvent = {}));

class TypedEventEmitter {
    emitter = new EventEmitter();
    emit(eventName, ...eventArg) {
        this.emitter.emit(eventName, ...eventArg);
    }
    on(eventName, handler) {
        this.emitter.on(eventName, handler);
    }
    removeListener(eventName, handler) {
        this.emitter.removeListener(eventName, handler);
    }
}

/**
 * ProviderErrors should take priority over RpcErrorCodes
 * https://eips.ethereum.org/EIPS/eip-1193#provider-errors
 * https://eips.ethereum.org/EIPS/eip-1474#error-codes
 */
var ProviderErrorCode;
(function (ProviderErrorCode) {
    ProviderErrorCode[ProviderErrorCode["USER_REJECTED_REQUEST"] = 4001] = "USER_REJECTED_REQUEST";
    ProviderErrorCode[ProviderErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
    ProviderErrorCode[ProviderErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
    ProviderErrorCode[ProviderErrorCode["DISCONNECTED"] = 4900] = "DISCONNECTED";
})(ProviderErrorCode || (ProviderErrorCode = {}));
var RpcErrorCode;
(function (RpcErrorCode) {
    RpcErrorCode[RpcErrorCode["RPC_SERVER_ERROR"] = -32000] = "RPC_SERVER_ERROR";
    RpcErrorCode[RpcErrorCode["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
    RpcErrorCode[RpcErrorCode["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
    RpcErrorCode[RpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    RpcErrorCode[RpcErrorCode["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
    RpcErrorCode[RpcErrorCode["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
    RpcErrorCode[RpcErrorCode["TRANSACTION_REJECTED"] = -32003] = "TRANSACTION_REJECTED";
})(RpcErrorCode || (RpcErrorCode = {}));
class JsonRpcError extends Error {
    message;
    code;
    constructor(code, message) {
        super(message);
        this.message = message;
        this.code = code;
    }
}

const buildOpenfortTransactions = async (transactionRequest, backendApiClients, instanceManager, policyId) => {
    const interactions = transactionRequest.map((tx) => {
        if (!tx.to) {
            throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, 'eth_sendTransaction requires a "to" field');
        }
        return {
            to: String(tx.to),
            data: tx.data ? String(tx.data) : undefined,
            value: tx.value ? String(tx.value) : undefined,
        };
    });
    const accessToken = instanceManager.getAccessToken();
    const chainId = instanceManager.getChainID();
    if (!accessToken || !chainId) {
        throw new JsonRpcError(RpcErrorCode.RPC_SERVER_ERROR, 'No access token found');
    }
    const transactionResponse = await backendApiClients.transactionIntentsApi.createTransactionIntent({
        createTransactionIntentRequest: {
            policy: policyId,
            chainId: Number(chainId),
            interactions,
        },
    }, {
        headers: {
            authorization: `Bearer ${backendApiClients.config.backend.accessToken}`,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'x-player-token': accessToken.token,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'x-auth-provider': accessToken.thirdPartyProvider,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'x-token-type': accessToken.thirdPartyTokenType,
        },
    });
    return transactionResponse.data;
};
const sendTransaction = async ({ params, signer, backendClient, instanceManager, policyId, }) => {
    const openfortTransaction = await buildOpenfortTransactions(params, backendClient, instanceManager, policyId);
    let response;
    if (openfortTransaction?.nextAction?.payload?.userOperationHash) {
        const signature = await signer.sign(openfortTransaction.nextAction.payload.userOperationHash);
        const openfortSignatureResponse = (await backendClient.transactionIntentsApi.signature({
            id: openfortTransaction.id,
            signatureRequest: { signature },
        })).data.response;
        if (!openfortSignatureResponse) {
            throw new JsonRpcError(RpcErrorCode.RPC_SERVER_ERROR, 'Transaction failed to submit');
        }
        response = openfortSignatureResponse;
    }
    else if (openfortTransaction.response) {
        response = openfortTransaction.response;
    }
    else {
        throw new JsonRpcError(RpcErrorCode.RPC_SERVER_ERROR, 'Transaction failed to submit');
    }
    if (response.status === 0 && !response.transactionHash) {
        throw new JsonRpcError(RpcErrorCode.RPC_SERVER_ERROR, response.error.reason);
    }
    return response.transactionHash;
};

const getSignedTypedData = async (typedData, accountType, chainId, signer, evmAddress) => {
    // Ethers auto-generates the EIP712Domain type in the TypedDataEncoder, and so it needs to be removed
    const types = { ...typedData.types };
    // @ts-ignore
    delete types.EIP712Domain;
    // Hash the EIP712 payload and generate the complete payload
    let typedDataHash = _TypedDataEncoder.hash(typedData.domain, types, typedData.message);
    if (accountType === AccountType.UPGRADEABLE_V5) {
        const updatedDomain = {
            name: 'Openfort',
            version: '0.5',
            chainId: Number(chainId),
            verifyingContract: evmAddress,
        };
        const updatedTypes = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            OpenfortMessage: [{ name: 'hashedMessage', type: 'bytes32' }],
        };
        const updatedMessage = {
            hashedMessage: typedDataHash,
        };
        typedDataHash = _TypedDataEncoder.hash(updatedDomain, updatedTypes, updatedMessage);
        // primaryType: "OpenfortMessage"
    }
    const ethsigNoType = await signer.sign(typedDataHash, false, false);
    return ethsigNoType;
};

const REQUIRED_TYPED_DATA_PROPERTIES = ['types', 'domain', 'primaryType', 'message'];
const isValidTypedDataPayload = (typedData) => (REQUIRED_TYPED_DATA_PROPERTIES.every((key) => key in typedData));
const transformTypedData = (typedData, chainId) => {
    let transformedTypedData;
    if (typeof typedData === 'string') {
        try {
            transformedTypedData = JSON.parse(typedData);
        }
        catch (err) {
            throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, `Failed to parse typed data JSON: ${err}`);
        }
    }
    else if (typeof typedData === 'object') {
        transformedTypedData = typedData;
    }
    else {
        throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, `Invalid typed data argument: ${typedData}`);
    }
    if (!isValidTypedDataPayload(transformedTypedData)) {
        throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, `Invalid typed data argument. The following properties are required: 
      ${REQUIRED_TYPED_DATA_PROPERTIES.join(', ')}`);
    }
    const providedChainId = transformedTypedData.domain?.chainId;
    if (providedChainId) {
        // domain.chainId (if defined) can be a number, string, or hex value, but the backend & guardian only accept a number.
        if (typeof providedChainId === 'string') {
            if (providedChainId.startsWith('0x')) {
                transformedTypedData.domain.chainId = parseInt(providedChainId, 16);
            }
            else {
                transformedTypedData.domain.chainId = parseInt(providedChainId, 10);
            }
        }
        if (transformedTypedData.domain.chainId !== chainId) {
            throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, `Invalid chainId, expected ${chainId}`);
        }
    }
    return transformedTypedData;
};
const signTypedDataV4 = async ({ params, method, signer, accountType, rpcProvider, }) => {
    const fromAddress = params[0];
    const typedDataParam = params[1];
    if (!fromAddress || !typedDataParam) {
        throw new JsonRpcError(RpcErrorCode.INVALID_PARAMS, `${method} requires an address and a typed data JSON`);
    }
    const { chainId } = await rpcProvider.detectNetwork();
    const typedData = transformTypedData(typedDataParam, chainId);
    const signature = await getSignedTypedData(typedData, accountType, chainId, signer, fromAddress);
    return signature;
};

class EvmProvider {
    #signer;
    #policyId;
    #eventEmitter;
    #rpcProvider; // Used for read
    #instanceManager;
    #backendApiClients;
    #address;
    isOpenfort = true;
    constructor({ signer, backendApiClients, instanceManager, openfortEventEmitter, policyId, }) {
        this.#signer = signer;
        this.#policyId = policyId;
        this.#instanceManager = instanceManager;
        this.#backendApiClients = backendApiClients;
        // default base mainnet as default chainId
        const chainId = Number(this.#instanceManager.getChainID() ?? 8453);
        this.#rpcProvider = new StaticJsonRpcProvider(chainMap[chainId].rpc[0]);
        this.#backendApiClients = backendApiClients;
        this.#eventEmitter = new TypedEventEmitter();
        openfortEventEmitter.on(OpenfortEvents.LOGGED_OUT, this.#handleLogout);
    }
    #handleLogout = () => {
        const shouldEmitAccountsChanged = !!this.#address;
        this.#address = undefined;
        this.#signer = undefined;
        if (shouldEmitAccountsChanged) {
            this.#eventEmitter.emit(ProviderEvent.ACCOUNTS_CHANGED, []);
        }
    };
    async #performRequest(request) {
        switch (request.method) {
            case 'eth_requestAccounts': {
                if (this.#address) {
                    return [this.#address];
                }
                if (!this.#signer) {
                    throw new JsonRpcError(ProviderErrorCode.UNAUTHORIZED, 'Unauthorized - must be authenticated and configured with a signer');
                }
                const user = await this.#signer.ensureEmbeddedAccount();
                this.#address = user.address;
                this.#eventEmitter.emit(ProviderEvent.ACCOUNTS_CHANGED, [this.#address]);
                return [this.#address];
            }
            case 'eth_sendTransaction': {
                if (!this.#address || !this.#signer) {
                    throw new JsonRpcError(ProviderErrorCode.UNAUTHORIZED, 'Unauthorized - call eth_requestAccounts first');
                }
                return await sendTransaction({
                    params: request.params || [],
                    signer: this.#signer,
                    backendClient: this.#backendApiClients,
                    instanceManager: this.#instanceManager,
                    policyId: this.#policyId,
                });
            }
            case 'eth_accounts': {
                if (this.#address) {
                    return [this.#address];
                }
                if (!this.#signer) {
                    throw new JsonRpcError(ProviderErrorCode.UNAUTHORIZED, 'Unauthorized - must be authenticated and configured with a signer');
                }
                const user = await this.#signer.ensureEmbeddedAccount();
                this.#address = user.address;
                this.#eventEmitter.emit(ProviderEvent.ACCOUNTS_CHANGED, [this.#address]);
                return [this.#address];
            }
            case 'eth_signTypedData':
            case 'eth_signTypedData_v4': {
                if (!this.#address || !this.#signer) {
                    throw new JsonRpcError(ProviderErrorCode.UNAUTHORIZED, 'Unauthorized - call eth_requestAccounts first');
                }
                const accountType = this.#instanceManager.getAccountType();
                if (!accountType) {
                    throw new JsonRpcError(ProviderErrorCode.UNAUTHORIZED, 'Unauthorized - call eth_requestAccounts first');
                }
                return await signTypedDataV4({
                    method: request.method,
                    params: request.params || [],
                    signer: this.#signer,
                    accountType,
                    rpcProvider: this.#rpcProvider,
                });
            }
            case 'eth_chainId': {
                // Call detect network to fetch the chainId so to take advantage of
                // the caching layer provided by StaticJsonRpcProvider.
                // In case Openfort is changed from StaticJsonRpcProvider to a
                // JsonRpcProvider, this function will still work as expected given
                // that detectNetwork call _uncachedDetectNetwork which will force
                // the provider to re-fetch the chainId from remote.
                const { chainId } = await this.#rpcProvider.detectNetwork();
                return hexlify(chainId);
            }
            // Pass through methods
            case 'eth_gasPrice':
            case 'eth_getBalance':
            case 'eth_getCode':
            case 'eth_getStorageAt':
            case 'eth_estimateGas':
            case 'eth_call':
            case 'eth_blockNumber':
            case 'eth_getBlockByHash':
            case 'eth_getBlockByNumber':
            case 'eth_getTransactionByHash':
            case 'eth_getTransactionReceipt':
            case 'eth_getTransactionCount': {
                return this.#rpcProvider.send(request.method, request.params || []);
            }
            default: {
                throw new JsonRpcError(ProviderErrorCode.UNSUPPORTED_METHOD, 'Method not supported');
            }
        }
    }
    async #performJsonRpcRequest(request) {
        const { id, jsonrpc } = request;
        try {
            const result = await this.#performRequest(request);
            return {
                id,
                jsonrpc,
                result,
            };
        }
        catch (error) {
            let jsonRpcError;
            if (error instanceof JsonRpcError) {
                jsonRpcError = error;
            }
            else if (error instanceof Error) {
                jsonRpcError = new JsonRpcError(RpcErrorCode.INTERNAL_ERROR, error.message);
            }
            else {
                jsonRpcError = new JsonRpcError(RpcErrorCode.INTERNAL_ERROR, 'Internal error');
            }
            return {
                id,
                jsonrpc,
                error: jsonRpcError,
            };
        }
    }
    async request(request) {
        try {
            return this.#performRequest(request);
        }
        catch (error) {
            if (error instanceof JsonRpcError) {
                throw error;
            }
            if (error instanceof Error) {
                throw new JsonRpcError(RpcErrorCode.INTERNAL_ERROR, error.message);
            }
            throw new JsonRpcError(RpcErrorCode.INTERNAL_ERROR, 'Internal error');
        }
    }
    sendAsync(request, callback) {
        if (!callback) {
            throw new Error('No callback provided');
        }
        if (Array.isArray(request)) {
            Promise.all(request.map(this.#performJsonRpcRequest)).then((result) => {
                callback(null, result);
            }).catch((error) => {
                callback(error, []);
            });
        }
        else {
            this.#performJsonRpcRequest(request).then((result) => {
                callback(null, result);
            }).catch((error) => {
                callback(error, null);
            });
        }
    }
    async send(request, callbackOrParams, callback) {
        // Web3 >= 1.0.0-beta.38 calls `send` with method and parameters.
        if (typeof request === 'string') {
            if (typeof callbackOrParams === 'function') {
                return this.sendAsync({
                    method: request,
                    params: [],
                }, callbackOrParams);
            }
            if (callback) {
                return this.sendAsync({
                    method: request,
                    params: Array.isArray(callbackOrParams) ? callbackOrParams : [],
                }, callback);
            }
            return this.request({
                method: request,
                params: Array.isArray(callbackOrParams) ? callbackOrParams : [],
            });
        }
        // Web3 <= 1.0.0-beta.37 uses `send` with a callback for async queries.
        if (typeof callbackOrParams === 'function') {
            return this.sendAsync(request, callbackOrParams);
        }
        if (!Array.isArray(request) && typeof request === 'object') {
            return this.#performJsonRpcRequest(request);
        }
        throw new JsonRpcError(RpcErrorCode.INVALID_REQUEST, 'Invalid request');
    }
    on(event, listener) {
        this.#eventEmitter.on(event, listener);
    }
    removeListener(event, listener) {
        this.#eventEmitter.removeListener(event, listener);
    }
}

const openfortProviderInfo = {
    // eslint-disable-next-line max-len
    icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="597.32 331.34 171.36 105.32" ><g><rect x="673.9" y="404.26" width="18.2" height="32.4" /><polygon points="768.68,331.36 768.68,331.36 768.68,331.34 610.78,331.34 610.78,331.36 597.32,331.36 597.32,436.64    615.52,436.64 615.52,349.54 750.48,349.54 750.48,436.64 768.68,436.64  " /><polygon points="732.16,367.79 633.83,367.79 633.83,370.19 633.79,370.19 633.79,436.64 651.99,436.64 651.99,385.99    713.9,385.99 713.9,436.64 732.09,436.64 732.09,385.99 732.16,385.99  " /></g></svg>',
    name: 'Openfort',
    rdns: 'xyz.openfort',
    uuid: v4(),
};
function announceProvider(detail) {
    if (typeof window === 'undefined')
        return;
    const event = new CustomEvent('eip6963:announceProvider', { detail: Object.freeze(detail) });
    window.dispatchEvent(event);
    const handler = () => window.dispatchEvent(event);
    window.addEventListener('eip6963:requestProvider', handler);
}

var OpenfortErrorType;
(function (OpenfortErrorType) {
    OpenfortErrorType["AUTHENTICATION_ERROR"] = "AUTHENTICATION_ERROR";
    OpenfortErrorType["INVALID_CONFIGURATION"] = "INVALID_CONFIGURATION";
    OpenfortErrorType["NOT_LOGGED_IN_ERROR"] = "NOT_LOGGED_IN_ERROR";
    OpenfortErrorType["REFRESH_TOKEN_ERROR"] = "REFRESH_TOKEN_ERROR";
    OpenfortErrorType["USER_REGISTRATION_ERROR"] = "USER_REGISTRATION_ERROR";
    OpenfortErrorType["LOGOUT_ERROR"] = "LOGOUT_ERROR";
    OpenfortErrorType["OPERATION_NOT_SUPPORTED_ERROR"] = "OPERATION_NOT_SUPPORTED_ERROR";
    OpenfortErrorType["MISSING_SESSION_SIGNER_ERROR"] = "MISSING_SESSION_SIGNER_ERROR";
    OpenfortErrorType["MISSING_EMBEDDED_SIGNER_ERROR"] = "MISSING_EMBEDDED_SIGNER_ERROR";
    OpenfortErrorType["MISSING_SIGNER_ERROR"] = "MISSING_SIGNER_ERROR";
    OpenfortErrorType["USER_NOT_AUTHORIZED_ON_ECOSYSTEM"] = "USER_NOT_AUTHORIZED_ON_ECOSYSTEM";
})(OpenfortErrorType || (OpenfortErrorType = {}));
function isAPIError(error) {
    return 'type' in error && 'message' in error;
}
class OpenfortError extends Error {
    type;
    data;
    constructor(message, type, data = {}) {
        super(message);
        this.type = type;
        this.data = data;
    }
}
const withOpenfortError = async (fn, customErrorType) => {
    try {
        return await fn();
    }
    catch (error) {
        let errorMessage;
        const data = {};
        let errorType = customErrorType.default;
        if (isAxiosError(error)) {
            const statusCode = error.response?.status;
            errorType = statusCode ? customErrorType[statusCode] || customErrorType.default : customErrorType.default;
            if (error.response?.data && error.response.data.error) {
                const jsonData = JSON.parse(JSON.stringify(error.response.data.error));
                // eslint-disable-next-line no-restricted-syntax
                for (const key in jsonData) {
                    if (key !== 'message' && key !== 'type') {
                        data[key] = jsonData[key];
                    }
                }
                if (isAPIError(error.response.data)) {
                    errorMessage = error.response.data.message;
                }
                else {
                    errorMessage = error.message;
                }
            }
            else {
                errorMessage = error.message;
            }
        }
        else {
            errorMessage = error.message;
        }
        throw new OpenfortError(errorMessage, errorType, data);
    }
};

var SignerType;
(function (SignerType) {
    SignerType["EMBEDDED"] = "embedded";
    SignerType["SESSION"] = "session";
})(SignerType || (SignerType = {}));

const isBrowser = () => typeof document !== 'undefined';

const KEY_PKCE_STATE = 'pkce_state';
const KEY_PKCE_VERIFIER = 'pkce_verifier';
class DeviceCredentialsManager {
    savePKCEData(data) {
        localStorage.setItem(KEY_PKCE_STATE, data.state);
        localStorage.setItem(KEY_PKCE_VERIFIER, data.verifier);
    }
    getPKCEData() {
        const state = localStorage.getItem(KEY_PKCE_STATE);
        const verifier = localStorage.getItem(KEY_PKCE_VERIFIER);
        if (state && verifier) {
            return { state, verifier };
        }
        return null;
    }
}

function base64URLEncode(str) {
    return str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
function sha256(buffer) {
    return crypto.createHash('sha256').update(buffer).digest();
}
class AuthManager {
    config;
    deviceCredentialsManager;
    instanceManager;
    backendApiClients;
    constructor(config, backendApiClients, instanceManager) {
        this.config = config;
        this.deviceCredentialsManager = new DeviceCredentialsManager();
        this.backendApiClients = backendApiClients;
        this.instanceManager = instanceManager;
    }
    async initOAuth(provider, options, ecosystemGame) {
        const usePooling = options?.usePooling ?? false;
        // eslint-disable-next-line no-param-reassign
        delete options?.usePooling;
        const request = {
            oAuthInitRequest: {
                provider,
                options,
                usePooling,
            },
        };
        const result = await this.backendApiClients.authenticationApi.initOAuth(request, AuthManager.getEcosystemGameOptsOrUndefined(ecosystemGame));
        if (isBrowser() && options?.skipBrowserRedirect) {
            window.location.assign(result.data.url);
        }
        return {
            url: result.data.url,
            key: result.data.key,
        };
    }
    async poolOAuth(key) {
        const request = {
            key,
        };
        for (let i = 0; i < 600; i++) {
            try {
                // eslint-disable-next-line no-await-in-loop
                const response = await this.backendApiClients.authenticationApi.poolOAuth(request);
                if (response.status === 200) {
                    this.instanceManager.setAccessToken({
                        token: response.data.token,
                        thirdPartyProvider: null,
                        thirdPartyTokenType: null,
                    });
                    this.instanceManager.setRefreshToken(response.data.refreshToken);
                    this.instanceManager.setPlayerID(response.data.player.id);
                    return response.data;
                }
            }
            catch (error) {
                // @ts-ignore
                if (error.response && error.response.status === 404) {
                    // eslint-disable-next-line no-await-in-loop
                    await new Promise((resolve) => { setTimeout(resolve, 500); });
                    // eslint-disable-next-line no-continue
                    continue;
                }
                throw error;
            }
        }
        throw new Error('Failed to pool OAuth, try again later');
    }
    async authenticateThirdParty(provider, token, tokenType, ecosystemGame) {
        const request = {
            thirdPartyOAuthRequest: {
                provider,
                token,
                tokenType,
            },
        };
        return withOpenfortError(async () => {
            const response = await this.backendApiClients.authenticationApi.thirdParty(request, AuthManager.getEcosystemGameOptsOrUndefined(ecosystemGame));
            return response.data;
        }, { default: OpenfortErrorType.AUTHENTICATION_ERROR });
    }
    async initSIWE(address, ecosystemGame) {
        const request = {
            sIWERequest: {
                address,
            },
        };
        const result = await this.backendApiClients.authenticationApi.initSIWE(request, AuthManager.getEcosystemGameOptsOrUndefined(ecosystemGame));
        return {
            address: result.data.address,
            nonce: result.data.nonce,
            expiresAt: result.data.expiresAt,
        };
    }
    async authenticateSIWE(signature, message, walletClientType, connectorType) {
        const request = {
            sIWEAuthenticateRequest: {
                signature,
                message,
                walletClientType,
                connectorType,
            },
        };
        return withOpenfortError(async () => {
            const response = await this.backendApiClients.authenticationApi.authenticateSIWE(request);
            return response.data;
        }, { default: OpenfortErrorType.AUTHENTICATION_ERROR });
    }
    static getEcosystemGameOptsOrUndefined(ecosystemGame) {
        if (ecosystemGame) {
            return {
                headers: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'x-game': ecosystemGame,
                },
            };
        }
        return undefined;
    }
    async loginEmailPassword(email, password, ecosystemGame) {
        const request = {
            loginRequest: {
                email,
                password,
            },
        };
        return withOpenfortError(async () => {
            const response = await this.backendApiClients.authenticationApi.loginEmailPassword(request, AuthManager.getEcosystemGameOptsOrUndefined(ecosystemGame));
            return response.data;
            // eslint-disable-next-line @typescript-eslint/naming-convention
        }, { default: OpenfortErrorType.AUTHENTICATION_ERROR, 403: OpenfortErrorType.USER_NOT_AUTHORIZED_ON_ECOSYSTEM });
    }
    async requestResetPassword(email, redirectUrl) {
        const verifier = base64URLEncode(crypto.randomBytes(32));
        const challenge = base64URLEncode(sha256(verifier));
        // https://auth0.com/docs/secure/attack-protection/state-parameters
        const state = base64URLEncode(crypto.randomBytes(32));
        this.deviceCredentialsManager.savePKCEData({ state, verifier });
        const request = {
            requestResetPasswordRequest: {
                email,
                redirectUrl,
                challenge: {
                    codeChallenge: challenge,
                    method: CodeChallengeMethodEnum.S256,
                },
            },
        };
        await this.backendApiClients.authenticationApi.requestResetPassword(request);
    }
    async resetPassword(email, password, state) {
        return withOpenfortError(async () => {
            const pkceData = this.deviceCredentialsManager.getPKCEData();
            if (!pkceData) {
                throw new Error('No code verifier or state for PKCE');
            }
            const request = {
                resetPasswordRequest: {
                    email,
                    password,
                    state,
                    challenge: {
                        codeVerifier: pkceData.verifier,
                    },
                },
            };
            await this.backendApiClients.authenticationApi.resetPassword(request);
        }, { default: OpenfortErrorType.AUTHENTICATION_ERROR });
    }
    async requestEmailVerification(email, redirectUrl) {
        const verifier = base64URLEncode(crypto.randomBytes(32));
        const challenge = base64URLEncode(sha256(verifier));
        // https://auth0.com/docs/secure/attack-protection/state-parameters
        const state = base64URLEncode(crypto.randomBytes(32));
        this.deviceCredentialsManager.savePKCEData({ state, verifier });
        const request = {
            requestVerifyEmailRequest: {
                email,
                redirectUrl,
                challenge: {
                    codeChallenge: challenge,
                    method: CodeChallengeMethodEnum.S256,
                },
            },
        };
        await this.backendApiClients.authenticationApi.requestEmailVerification(request);
    }
    async verifyEmail(email, state) {
        return withOpenfortError(async () => {
            const pkceData = this.deviceCredentialsManager.getPKCEData();
            if (!pkceData) {
                throw new Error('No code verifier or state for PKCE');
            }
            const request = {
                verifyEmailRequest: {
                    email,
                    token: state,
                    challenge: {
                        codeVerifier: pkceData.verifier,
                    },
                },
            };
            await this.backendApiClients.authenticationApi.verifyEmail(request);
        }, { default: OpenfortErrorType.AUTHENTICATION_ERROR });
    }
    async signupEmailPassword(email, password, name, ecosystemGame) {
        const request = {
            signupRequest: {
                email,
                password,
                name,
            },
        };
        return withOpenfortError(async () => {
            const response = await this.backendApiClients.authenticationApi.signupEmailPassword(request, AuthManager.getEcosystemGameOptsOrUndefined(ecosystemGame));
            return response.data;
        }, { default: OpenfortErrorType.USER_REGISTRATION_ERROR });
    }
    async validateCredentials(forceRefresh) {
        const jwk = await this.instanceManager.getJWK();
        const accessToken = this.instanceManager.getAccessToken()?.token;
        const refreshToken = this.instanceManager.getRefreshToken();
        if (!accessToken || !refreshToken || !jwk) {
            throw new OpenfortError('Must be logged in to validate and refresh token', OpenfortErrorType.NOT_LOGGED_IN_ERROR);
        }
        if (forceRefresh) {
            return this.refreshTokens(refreshToken, forceRefresh);
        }
        try {
            const key = (await importJWK({
                kty: jwk.kty,
                crv: jwk.crv,
                x: jwk.x,
                y: jwk.y,
            }, jwk.alg));
            const verification = await jwtVerify(accessToken, key);
            return {
                player: verification.payload.sub,
                accessToken,
                refreshToken,
            };
        }
        catch (error) {
            if (error instanceof errors.JWTExpired) {
                return this.refreshTokens(refreshToken);
            }
            throw error;
        }
    }
    async refreshTokens(refreshToken, forceRefresh) {
        const request = {
            refreshTokenRequest: {
                refreshToken,
                forceRefresh,
            },
        };
        return withOpenfortError(async () => {
            const response = await this.backendApiClients.authenticationApi.refresh(request);
            return {
                player: response.data.player.id,
                accessToken: response.data.token,
                refreshToken: response.data.refreshToken,
            };
        }, { default: OpenfortErrorType.REFRESH_TOKEN_ERROR });
    }
    async logout(accessToken, refreshToken) {
        const request = {
            logoutRequest: {
                refreshToken,
            },
        };
        withOpenfortError(async () => {
            await this.backendApiClients.authenticationApi.logout(request, {
                headers: {
                    authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'x-player-token': accessToken,
                },
            });
        }, { default: OpenfortErrorType.LOGOUT_ERROR });
    }
    async getUser(accessToken) {
        // TODO: Add storage of user info
        const response = await this.backendApiClients.authenticationApi.me({
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
            },
        });
        return response.data;
    }
    async linkOAuth(provider, playerToken, options, ecosystemGame) {
        const request = {
            oAuthInitRequest: {
                provider,
                options,
                usePooling: options?.usePooling || false,
            },
        };
        const result = await this.backendApiClients.authenticationApi.linkOAuth(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': playerToken,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-game': ecosystemGame || undefined,
            },
        });
        if (isBrowser() && !options?.skipBrowserRedirect) {
            window.location.assign(result.data.url);
        }
        return {
            url: result.data.url,
            key: result.data.key,
        };
    }
    async unlinkOAuth(provider, accessToken) {
        const request = {
            unlinkOAuthRequest: {
                provider,
            },
        };
        const authPlayerResponse = await this.backendApiClients.authenticationApi.unlinkOAuth(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
            },
        });
        return authPlayerResponse.data;
    }
    async unlinkWallet(address, accessToken) {
        const request = {
            sIWERequest: {
                address,
            },
        };
        const authPlayerResponse = await this.backendApiClients.authenticationApi.unlinkSIWE(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
            },
        });
        return authPlayerResponse.data;
    }
    async linkWallet(signature, message, walletClientType, connectorType, accessToken) {
        const request = {
            sIWEAuthenticateRequest: {
                signature,
                message,
                walletClientType,
                connectorType,
            },
        };
        const authPlayerResponse = await this.backendApiClients.authenticationApi.linkSIWE(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
            },
        });
        return authPlayerResponse.data;
    }
    async unlinkEmail(email, accessToken) {
        const request = {
            unlinkEmailRequest: {
                email,
            },
        };
        const authPlayerResponse = await this.backendApiClients.authenticationApi.unlinkEmail(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
            },
        });
        return authPlayerResponse.data;
    }
    async linkEmail(email, password, accessToken, ecosystemGame) {
        const request = {
            loginRequest: {
                email,
                password,
            },
        };
        const authPlayerResponse = await this.backendApiClients.authenticationApi.linkEmail(request, {
            headers: {
                authorization: `Bearer ${this.config.baseConfiguration.publishableKey}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-player-token': accessToken,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'x-game': ecosystemGame || undefined,
            },
        });
        return authPlayerResponse.data;
    }
}

const VERSION = '0.7.26';

var Event;
(function (Event) {
    Event["LOADED"] = "loaded";
    Event["CONFIGURE"] = "configure";
    Event["CONFIGURED"] = "configured";
    Event["UPDATE_AUTHENTICATION"] = "update-authentication";
    Event["AUTHENTICATION_UPDATED"] = "authentication-updated";
    Event["SIGN"] = "sign";
    Event["EXPORT"] = "export";
    Event["SIGNED"] = "signed";
    Event["LOGOUT"] = "logout";
    Event["LOGGED_OUT"] = "logged-out";
    Event["GET_CURRENT_DEVICE"] = "get-current-device";
    Event["CURRENT_DEVICE"] = "current-device";
    Event["PING"] = "ping";
    Event["PONG"] = "pong";
})(Event || (Event = {}));
const NOT_CONFIGURED_ERROR = 'not-configured-error';
const MISSING_USER_ENTROPY_ERROR = 'missing-user-entropy-error';
const MISSING_PROJECT_ENTROPY_ERROR = 'missing-project-entropy-error';
const INCORRECT_USER_ENTROPY_ERROR = 'incorrect-user-entropy-error';
class GetCurrentDeviceRequest {
    uuid;
    action = Event.GET_CURRENT_DEVICE;
    playerID;
    constructor(uuid, playerId) {
        this.uuid = uuid;
        this.playerID = playerId;
    }
}
class PingRequest {
    uuid;
    action = Event.PING;
    constructor(uuid) {
        this.uuid = uuid;
    }
}
class GetCurrentDeviceResponse {
    uuid;
    success;
    action = Event.CURRENT_DEVICE;
    deviceID;
    accountType;
    version = null;
    chainId;
    address;
    constructor(uuid, deviceID, accountType, chainId, address) {
        this.uuid = uuid;
        this.success = true;
        this.deviceID = deviceID;
        this.accountType = accountType;
        this.chainId = chainId;
        this.address = address;
    }
}
class LogoutRequest {
    uuid;
    action = Event.LOGOUT;
    constructor(uuid) {
        this.uuid = uuid;
    }
}
class SignRequest {
    uuid;
    action = Event.SIGN;
    message;
    requireArrayify;
    requireHash;
    requestConfiguration;
    constructor(uuid, message, requireArrayify, requireHash, requestConfiguration) {
        this.uuid = uuid;
        this.message = message;
        this.requireArrayify = requireArrayify;
        this.requireHash = requireHash;
        this.requestConfiguration = requestConfiguration;
    }
}
class ExportPrivateKeyRequest {
    uuid;
    action = Event.EXPORT;
    requestConfiguration;
    constructor(uuid, requestConfiguration) {
        this.uuid = uuid;
        this.requestConfiguration = requestConfiguration;
    }
}
class ExportPrivateKeyResponse {
    uuid;
    success;
    action = Event.EXPORT;
    key;
    version = VERSION;
    constructor(uuid, key) {
        this.success = true;
        this.key = key;
        this.uuid = uuid;
    }
}
function isErrorResponse(response) {
    return 'error' in response;
}
class ConfigureResponse {
    uuid;
    success;
    deviceID;
    address;
    chainId;
    accountType;
    action = Event.CONFIGURED;
    version;
    constructor(uuid, deviceID, accountType, chainId, address) {
        this.success = true;
        this.deviceID = deviceID;
        this.uuid = uuid;
        this.accountType = accountType;
        this.chainId = chainId;
        this.address = address;
        this.version = null;
    }
}
class UpdateAuthenticationResponse {
    uuid;
    success;
    action = Event.AUTHENTICATION_UPDATED;
    version;
    constructor(uuid) {
        this.success = true;
        this.uuid = uuid;
        this.version = null;
    }
}
class SignResponse {
    uuid;
    success;
    signature;
    action = Event.SIGNED;
    version;
    constructor(uuid, signature) {
        this.success = true;
        this.signature = signature;
        this.uuid = uuid;
        this.version = null;
    }
}
class LogoutResponse {
    uuid;
    success;
    action = Event.LOGGED_OUT;
    constructor(uuid) {
        this.success = true;
        this.uuid = uuid;
    }
}
class UpdateAuthenticationRequest {
    uuid;
    action = Event.UPDATE_AUTHENTICATION;
    accessToken;
    recovery;
    constructor(uuid, accessToken, recovery) {
        this.uuid = uuid;
        this.accessToken = accessToken;
        this.recovery = recovery;
    }
}
var ShieldAuthType;
(function (ShieldAuthType) {
    ShieldAuthType["OPENFORT"] = "openfort";
    ShieldAuthType["CUSTOM"] = "custom";
})(ShieldAuthType || (ShieldAuthType = {}));

const authTokenStorageKey = 'openfort.auth_token';
const thirdPartyProviderStorageKey = 'openfort.third_party_provider';
const thirdPartyProviderTokenTypeStorageKey = 'openfort.third_party_provider_token_type';
const refreshTokenStorageKey = 'openfort.refresh_token';
const playerIDStorageKey = 'openfort.player_id';
const sessionKeyStorageKey = 'openfort.session_key';
const signerTypeStorageKey = 'openfort.signer_type';
const chainIDStorageKey = 'openfort.chain_id';
const jwksStorageKey = 'openfort.jwk';
const deviceIDStorageKey = 'openfort.device_id';
const accountTypeStorageKey = 'openfort.account_type';
const shieldAuthTypeStorageKey = 'openfort.shield_auth_type';
const shieldAuthTokenStorageKey = 'openfort.shield_auth_token';
const accountAddressStorageKey = 'openfort.account_address';

class InstanceManager {
    authToken = null;
    refreshToken = null;
    signerType = null;
    jwk = null;
    sessionKey = null;
    deviceID = null;
    shieldAuthType = null;
    authShieldToken = null;
    chainId = null;
    accountAddress = null;
    accountType = null;
    temporalStorage;
    persistentStorage;
    secureStorage;
    config;
    backendApiClients;
    playerId = null;
    constructor(temporalStorage, persistentStorage, secureStorage, config, backendApiClients) {
        this.temporalStorage = temporalStorage;
        this.persistentStorage = persistentStorage;
        this.secureStorage = secureStorage;
        this.config = config;
        this.backendApiClients = backendApiClients;
    }
    getAccessToken() {
        if (!this.authToken) {
            const token = this.secureStorage.get(authTokenStorageKey);
            if (token === null)
                return null;
            this.authToken = {
                token,
                thirdPartyProvider: this.secureStorage.get(thirdPartyProviderStorageKey),
                thirdPartyTokenType: this.secureStorage.get(thirdPartyProviderTokenTypeStorageKey),
            };
        }
        return this.authToken;
    }
    setAccessToken(accessToken) {
        this.authToken = accessToken;
        this.secureStorage.save(authTokenStorageKey, accessToken.token);
        if (accessToken.thirdPartyProvider) {
            this.secureStorage.save(thirdPartyProviderStorageKey, accessToken.thirdPartyProvider);
        }
        if (accessToken.thirdPartyTokenType) {
            this.secureStorage.save(thirdPartyProviderTokenTypeStorageKey, accessToken.thirdPartyTokenType);
        }
    }
    removeAccessToken() {
        this.authToken = null;
        this.secureStorage.remove(authTokenStorageKey);
        this.secureStorage.remove(thirdPartyProviderStorageKey);
        this.secureStorage.remove(thirdPartyProviderTokenTypeStorageKey);
    }
    getRefreshToken() {
        if (!this.refreshToken) {
            this.refreshToken = this.secureStorage.get(refreshTokenStorageKey);
        }
        return this.refreshToken;
    }
    setRefreshToken(refreshToken) {
        this.refreshToken = refreshToken;
        this.secureStorage.save(refreshTokenStorageKey, refreshToken);
    }
    removeRefreshToken() {
        this.refreshToken = null;
        this.secureStorage.remove(refreshTokenStorageKey);
    }
    setPlayerID(playerID) {
        this.playerId = playerID;
        this.persistentStorage.save(playerIDStorageKey, playerID);
    }
    getPlayerID() {
        if (this.playerId === null) {
            this.playerId = this.persistentStorage.get(playerIDStorageKey);
        }
        return this.playerId;
    }
    removePlayerID() {
        this.playerId = null;
        this.persistentStorage.remove(playerIDStorageKey);
    }
    setSignerType(signerType) {
        this.signerType = signerType;
        this.temporalStorage.save(signerTypeStorageKey, signerType);
    }
    getSignerType() {
        if (!this.signerType) {
            this.signerType = this.temporalStorage.get(signerTypeStorageKey);
        }
        if (!this.signerType) {
            if (this.getSessionKey()) {
                this.signerType = SignerType.SESSION;
            }
            else if (this.getDeviceID()) {
                this.signerType = SignerType.EMBEDDED;
            }
        }
        return this.signerType;
    }
    removeSignerType() {
        this.signerType = null;
        this.temporalStorage.remove(signerTypeStorageKey);
    }
    setJWK(jwk) {
        this.jwk = jwk;
        this.temporalStorage.save(jwksStorageKey, InstanceManager.jwkToString(jwk));
    }
    static jwkToString(jwk) {
        return JSON.stringify({
            kty: jwk.kty,
            crv: jwk.crv,
            x: jwk.x,
            y: jwk.y,
            alg: jwk.alg,
        });
    }
    static stringToJWK(jwkString) {
        const json = JSON.parse(jwkString);
        return {
            kty: json.kty,
            crv: json.crv,
            x: json.x,
            y: json.y,
            alg: json.alg,
        };
    }
    async getJWK() {
        if (!this.jwk) {
            const jwkString = this.temporalStorage.get(jwksStorageKey);
            if (jwkString) {
                this.jwk = InstanceManager.stringToJWK(jwkString);
            }
        }
        if (!this.jwk) {
            const request = {
                publishableKey: this.config.baseConfiguration.publishableKey,
            };
            const response = await this.backendApiClients.authenticationApi.getJwks(request);
            if (response.data.keys.length === 0) {
                throw new Error('Internal error: No JWKS keys found');
            }
            const jwtKey = response.data.keys[0];
            this.setJWK(jwtKey);
            this.jwk = {
                kty: jwtKey.kty,
                crv: jwtKey.crv,
                x: jwtKey.x,
                y: jwtKey.y,
                alg: jwtKey.alg,
            };
        }
        return this.jwk;
    }
    removeJWK() {
        this.jwk = null;
        this.temporalStorage.remove(jwksStorageKey);
    }
    getSessionKey() {
        if (!this.sessionKey) {
            this.sessionKey = this.persistentStorage.get(sessionKeyStorageKey);
        }
        return this.sessionKey;
    }
    setSessionKey(sessionKey) {
        this.sessionKey = sessionKey;
        this.persistentStorage.save(sessionKeyStorageKey, sessionKey);
    }
    removeSessionKey() {
        this.sessionKey = null;
        this.persistentStorage.remove(sessionKeyStorageKey);
    }
    setDeviceID(deviceID) {
        this.deviceID = deviceID;
        this.persistentStorage.save(deviceIDStorageKey, deviceID);
    }
    getDeviceID() {
        if (!this.deviceID) {
            this.deviceID = this.persistentStorage.get(deviceIDStorageKey);
        }
        return this.deviceID;
    }
    removeDeviceID() {
        this.deviceID = null;
        this.persistentStorage.remove(deviceIDStorageKey);
    }
    setChainID(chainId) {
        this.chainId = chainId;
        this.persistentStorage.save(chainIDStorageKey, chainId);
    }
    getChainID() {
        if (!this.chainId) {
            this.chainId = this.persistentStorage.get(chainIDStorageKey);
        }
        return this.chainId;
    }
    removeChainID() {
        this.chainId = null;
        this.persistentStorage.remove(chainIDStorageKey);
    }
    setAccountAddress(accountAddress) {
        this.accountAddress = accountAddress;
        this.persistentStorage.save(accountAddressStorageKey, accountAddress);
    }
    getAccountAddress() {
        if (!this.accountAddress) {
            this.accountAddress = this.persistentStorage.get(accountAddressStorageKey);
        }
        return this.accountAddress;
    }
    removeAccountAddress() {
        this.accountAddress = null;
        this.persistentStorage.remove(accountAddressStorageKey);
    }
    setAccountType(accountType) {
        this.accountType = accountType;
        this.persistentStorage.save(accountTypeStorageKey, accountType);
    }
    getAccountType() {
        if (!this.accountType) {
            this.accountType = this.persistentStorage.get(accountTypeStorageKey);
        }
        return this.accountType;
    }
    removeAccountType() {
        this.accountType = null;
        this.persistentStorage.remove(accountTypeStorageKey);
    }
    setShieldAuthType(shieldAuthType) {
        this.shieldAuthType = shieldAuthType;
        this.persistentStorage.save(shieldAuthTypeStorageKey, shieldAuthType);
    }
    getShieldAuthType() {
        if (!this.shieldAuthType) {
            this.shieldAuthType = this.persistentStorage.get(shieldAuthTypeStorageKey);
            if (this.shieldAuthType === null) {
                // TODO: remove, this is for backward compatibility
                this.setShieldAuthType(ShieldAuthType.OPENFORT);
                this.shieldAuthType = ShieldAuthType.OPENFORT;
            }
        }
        return this.shieldAuthType;
    }
    removeShieldAuthType() {
        this.shieldAuthType = null;
        this.persistentStorage.remove(shieldAuthTypeStorageKey);
    }
    setShieldAuthToken(authShieldToken) {
        this.authShieldToken = authShieldToken;
        this.persistentStorage.save(shieldAuthTokenStorageKey, authShieldToken);
    }
    getShieldAuthToken() {
        if (!this.authShieldToken) {
            this.authShieldToken = this.persistentStorage.get(shieldAuthTokenStorageKey);
        }
        return this.authShieldToken;
    }
    removeShieldAuthToken() {
        this.authShieldToken = null;
        this.persistentStorage.remove(shieldAuthTokenStorageKey);
    }
}

class LocalStorage {
    static validateLocalStorage() {
        if (!(typeof window !== 'undefined' && !!window.localStorage)) {
            throw new Error('Local storage is not available');
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get(key) {
        LocalStorage.validateLocalStorage();
        return localStorage.getItem(key);
    }
    // eslint-disable-next-line class-methods-use-this
    save(key, value) {
        LocalStorage.validateLocalStorage();
        localStorage.setItem(key, value);
    }
    // eslint-disable-next-line class-methods-use-this
    remove(key) {
        LocalStorage.validateLocalStorage();
        localStorage.removeItem(key);
    }
}

class KeyPair extends SigningKey {
    /**
     * Initialize keypair based on the private key, if it is provided or generate a brand new keypair.
     * @param privateKey Optional parameter to initialize private key from
     */
    constructor(privateKey = secp256k1.utils.randomPrivateKey()) {
        super(privateKey);
    }
    /**
     * Sign the message with the private key
     * @param message Message to sign
     */
    sign(message) {
        return joinSignature(this.signDigest(hashMessage(arrayify(message))));
    }
    /**
     * Load private key from the storage and generate keypair based on it.
     */
    static load(privateKey) {
        return privateKey ? new KeyPair(arrayify(privateKey)) : null;
    }
    /**
     * Return the address for the keypair
     */
    getPublicKey() {
        return computeAddress(this.privateKey);
    }
    getPrivateKey() {
        return this.privateKey;
    }
}

class SessionSigner {
    sessionKey;
    instanceManager;
    constructor(instanceManager) {
        this.instanceManager = instanceManager;
        this.sessionKey = null;
    }
    async sign(message) {
        if (this.sessionKey === null) {
            throw new Error('Session key is not loaded.');
        }
        return this.sessionKey.sign(message);
    }
    async logout() {
        this.instanceManager.removeSessionKey();
        this.sessionKey = null;
    }
    loadKeys() {
        if (this.sessionKey) {
            return this.sessionKey.getPublicKey();
        }
        const sessionKey = this.instanceManager.getSessionKey();
        if (sessionKey === null) {
            return null;
        }
        this.sessionKey = KeyPair.load(sessionKey);
        if (this.sessionKey === null) {
            return null;
        }
        return this.sessionKey.getPublicKey();
    }
    generateKeys() {
        this.sessionKey = new KeyPair();
        this.instanceManager.setSessionKey(this.sessionKey.getPrivateKey());
        return this.sessionKey.getPublicKey();
    }
    // eslint-disable-next-line class-methods-use-this
    getSingerType() {
        return SignerType.SESSION;
    }
    // eslint-disable-next-line class-methods-use-this
    useCredentials() {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    updateAuthentication() {
        return Promise.resolve();
    }
    export() {
        if (this.sessionKey === null) {
            throw new Error('Session key is not loaded.');
        }
        return Promise.resolve(this.sessionKey.getPrivateKey());
    }
}

class EmbeddedSigner {
    iframeManager;
    iframeConfiguration;
    instanceManager;
    constructor(iframeManager, instanceManager, iframeConfiguration) {
        this.instanceManager = instanceManager;
        this.iframeManager = iframeManager;
        this.iframeConfiguration = iframeConfiguration;
    }
    async logout() {
        await this.iframeManager.logout();
        this.instanceManager.removeDeviceID();
    }
    // eslint-disable-next-line class-methods-use-this
    useCredentials() {
        return true;
    }
    async updateAuthentication() {
        const accessToken = this.instanceManager.getAccessToken();
        if (!accessToken) {
            return;
        }
        const shieldAuthType = this.instanceManager.getShieldAuthType();
        await this.iframeManager.updateAuthentication(this.iframeConfiguration, accessToken.token, shieldAuthType);
    }
    // eslint-disable-next-line class-methods-use-this
    getSingerType() {
        return SignerType.EMBEDDED;
    }
    async ensureEmbeddedAccount(encryptionSession, recoveryPassword) {
        const playerID = this.instanceManager.getPlayerID();
        let currentUser = await this.iframeManager.getCurrentUser(playerID);
        if (currentUser?.deviceID) {
            return currentUser;
        }
        if (encryptionSession && this.iframeConfiguration.recovery) {
            this.iframeConfiguration.recovery.encryptionSession = encryptionSession;
        }
        currentUser = await this.iframeManager.configure(this.iframeConfiguration, recoveryPassword);
        if (!currentUser.accountType || !currentUser.chainId || !currentUser.address || !currentUser.deviceID) {
            throw new Error('Internal error: failed to configure the signer.');
        }
        this.instanceManager.setDeviceID(currentUser.deviceID);
        this.instanceManager.setAccountAddress(currentUser.address);
        this.instanceManager.setChainID(currentUser.chainId.toString());
        this.instanceManager.setAccountType(currentUser.accountType);
        return currentUser;
    }
    async sign(message, requireArrayify, requireHash) {
        const loaded = await this.isLoaded();
        if (!loaded) {
            throw new Error('Signer is not loaded');
        }
        return await this.iframeManager.sign(this.iframeConfiguration, message, requireArrayify, requireHash);
    }
    async export() {
        const loaded = await this.isLoaded();
        if (!loaded) {
            throw new Error('Signer is not loaded');
        }
        return await this.iframeManager.export(this.iframeConfiguration);
    }
    getDeviceID() {
        return this.instanceManager.getDeviceID();
    }
    async isLoaded() {
        if (this.instanceManager.getDeviceID()) {
            return true;
        }
        const playerID = this.instanceManager.getPlayerID();
        if (!playerID) {
            return false;
        }
        const localStorageUser = await this.iframeManager.getCurrentUser(playerID);
        if (localStorageUser?.deviceID) {
            this.instanceManager.setDeviceID(localStorageUser.deviceID);
            return true;
        }
        return false;
    }
    iFrameLoaded() {
        return this.iframeManager.isLoaded();
    }
}

class SessionStorage {
    static validateSessionStorage() {
        if (!(typeof window !== 'undefined' && !!window.localStorage)) {
            throw new Error('Session storage is not available');
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get(key) {
        SessionStorage.validateSessionStorage();
        return sessionStorage.getItem(key);
    }
    // eslint-disable-next-line class-methods-use-this
    save(key, value) {
        SessionStorage.validateSessionStorage();
        sessionStorage.setItem(key, value);
    }
    // eslint-disable-next-line class-methods-use-this
    remove(key) {
        SessionStorage.validateSessionStorage();
        sessionStorage.removeItem(key);
    }
}

class MissingRecoveryPasswordError extends Error {
    constructor() {
        super('This embedded signer requires a password to be recovered');
    }
}
class MissingProjectEntropyError extends Error {
    constructor() {
        super('MissingProjectEntropyError');
    }
}
class WrongRecoveryPasswordError extends Error {
    constructor() {
        super('Wrong recovery password for this embedded signer');
    }
}
class NoResponseError extends Error {
    constructor() {
        super('No response from iframe');
    }
}
class UnknownResponseError extends Error {
    message;
    constructor(message) {
        super(`Unknown response from iframe: ${message}`);
        this.message = message || '';
    }
}
class InvalidResponseError extends Error {
    constructor() {
        super('Invalid response from iframe');
    }
}
class NotConfiguredError extends Error {
    constructor() {
        super('Not configured');
    }
}
class IframeManager {
    iframe;
    responses = new Map();
    sdkConfiguration;
    constructor(configuration) {
        this.sdkConfiguration = configuration;
    }
    async iframeSetup() {
        window.addEventListener('message', (event) => {
            if (event.origin === this.sdkConfiguration.iframeUrl) {
                const { data } = event;
                if (data.action) {
                    if (data.action === Event.PONG) {
                        this.responses.set('FIRST', data);
                    }
                    this.responses.set(data.uuid, data);
                }
            }
        });
        const previousIframe = document.getElementById('openfort-iframe');
        if (previousIframe) {
            document.body.removeChild(previousIframe);
        }
        this.iframe = document.createElement('iframe');
        this.iframe.style.display = 'none';
        this.iframe.id = 'openfort-iframe';
        document.body.appendChild(this.iframe);
        if (this.sdkConfiguration.shieldConfiguration?.debug) {
            this.iframe.src = `${this.sdkConfiguration.iframeUrl}?debug=true`;
        }
        else {
            this.iframe.src = this.sdkConfiguration.iframeUrl;
        }
    }
    isLoaded() {
        return this.responses.get('FIRST') !== undefined;
    }
    async waitForIframeLoad() {
        if (!this.iframe) {
            await this.iframeSetup();
        }
        const checkAndPing = async () => {
            if (!this.isLoaded()) {
                this.iframe?.contentWindow?.postMessage(new PingRequest(this.generateShortUUID()), '*');
                await new Promise((resolve) => {
                    setTimeout(resolve, 100);
                });
                await checkAndPing();
            }
        };
        await checkAndPing();
    }
    responseConstructors = {
        [Event.CONFIGURED]: ConfigureResponse,
        [Event.AUTHENTICATION_UPDATED]: UpdateAuthenticationResponse,
        [Event.CURRENT_DEVICE]: GetCurrentDeviceResponse,
        [Event.SIGNED]: SignResponse,
        [Event.LOGGED_OUT]: LogoutResponse,
        [Event.EXPORT]: ExportPrivateKeyResponse,
    };
    waitForResponse(uuid) {
        return new Promise((resolve, reject) => {
            let retries = 0;
            const interval = setInterval(() => {
                if (retries > 100) {
                    clearInterval(interval);
                    reject(NoResponseError);
                }
                retries++;
                const response = this.responses.get(uuid);
                if (response) {
                    clearInterval(interval);
                    this.responses.delete(uuid);
                    // @ts-ignore
                    const responseConstructor = this.responseConstructors[response.action];
                    if (isErrorResponse(response)) {
                        if (response.error === NOT_CONFIGURED_ERROR) {
                            reject(new NotConfiguredError());
                        }
                        else if (response.error === MISSING_USER_ENTROPY_ERROR) {
                            reject(new MissingRecoveryPasswordError());
                        }
                        else if (response.error === MISSING_PROJECT_ENTROPY_ERROR) {
                            reject(new MissingProjectEntropyError());
                        }
                        else if (response.error === INCORRECT_USER_ENTROPY_ERROR) {
                            reject(new WrongRecoveryPasswordError());
                        }
                        reject(new UnknownResponseError(response.error));
                    }
                    else if (responseConstructor) {
                        resolve(response);
                    }
                    else {
                        reject(new InvalidResponseError());
                    }
                }
            }, 100);
        });
    }
    async configure(iframeConfiguration, password) {
        if (!this.sdkConfiguration.shieldConfiguration) {
            throw new Error('shieldConfiguration is required');
        }
        await this.waitForIframeLoad();
        const config = {
            uuid: this.generateShortUUID(),
            action: Event.CONFIGURE,
            chainId: iframeConfiguration.chainId,
            recovery: iframeConfiguration.recovery,
            publishableKey: this.sdkConfiguration.baseConfiguration.publishableKey,
            shieldAPIKey: this.sdkConfiguration.shieldConfiguration.shieldPublishableKey,
            accessToken: iframeConfiguration.accessToken,
            playerID: iframeConfiguration.playerID,
            thirdPartyProvider: iframeConfiguration.thirdPartyProvider,
            thirdPartyTokenType: iframeConfiguration.thirdPartyTokenType,
            encryptionKey: password ?? null,
            encryptionPart: this.sdkConfiguration?.shieldConfiguration?.shieldEncryptionKey ?? null,
            encryptionSession: iframeConfiguration.recovery?.encryptionSession ?? null,
            openfortURL: this.sdkConfiguration.backendUrl,
            shieldURL: this.sdkConfiguration.shieldUrl,
        };
        this.iframe?.contentWindow?.postMessage(config, '*');
        const response = await this.waitForResponse(config.uuid);
        sessionStorage.setItem('iframe-version', response.version ?? 'undefined');
        return response;
    }
    async sign(iframeConfiguration, message, requireArrayify, requireHash) {
        await this.waitForIframeLoad();
        const uuid = this.generateShortUUID();
        const requestConfiguration = {
            thirdPartyProvider: iframeConfiguration.thirdPartyProvider ?? undefined,
            thirdPartyTokenType: iframeConfiguration.thirdPartyTokenType ?? undefined,
            token: iframeConfiguration.accessToken ?? undefined,
            publishableKey: this.sdkConfiguration.baseConfiguration.publishableKey,
            openfortURL: this.sdkConfiguration.backendUrl,
        };
        const request = new SignRequest(uuid, message, requireArrayify, requireHash, requestConfiguration);
        this.iframe?.contentWindow?.postMessage(request, '*');
        let response;
        try {
            response = await this.waitForResponse(uuid);
        }
        catch (e) {
            if (e instanceof NotConfiguredError) {
                await this.configure(iframeConfiguration);
                return this.sign(iframeConfiguration, message, requireArrayify, requireHash);
            }
            throw e;
        }
        sessionStorage.setItem('iframe-version', response.version ?? 'undefined');
        return response.signature;
    }
    async export(iframeConfiguration) {
        await this.waitForIframeLoad();
        const uuid = this.generateShortUUID();
        const requestConfiguration = {
            thirdPartyProvider: iframeConfiguration.thirdPartyProvider ?? undefined,
            thirdPartyTokenType: iframeConfiguration.thirdPartyTokenType ?? undefined,
            token: iframeConfiguration.accessToken ?? undefined,
            publishableKey: this.sdkConfiguration.baseConfiguration.publishableKey,
            openfortURL: this.sdkConfiguration.backendUrl,
        };
        const request = new ExportPrivateKeyRequest(uuid, requestConfiguration);
        this.iframe?.contentWindow?.postMessage(request, '*');
        let response;
        try {
            response = await this.waitForResponse(uuid);
        }
        catch (e) {
            if (e instanceof NotConfiguredError) {
                await this.configure(iframeConfiguration);
                return this.export(iframeConfiguration);
            }
            throw e;
        }
        sessionStorage.setItem('iframe-version', response.version ?? 'undefined');
        return response.key;
    }
    async getCurrentUser(playerId) {
        await this.waitForIframeLoad();
        const uuid = this.generateShortUUID();
        const request = new GetCurrentDeviceRequest(uuid, playerId);
        this.iframe?.contentWindow?.postMessage(request, '*');
        try {
            const response = await this.waitForResponse(uuid);
            sessionStorage.setItem('iframe-version', response.version ?? 'undefined');
            return response;
        }
        catch (e) {
            if (e instanceof NotConfiguredError) {
                return null;
            }
            throw e;
        }
    }
    async logout() {
        await this.waitForIframeLoad();
        const uuid = this.generateShortUUID();
        const request = new LogoutRequest(uuid);
        this.iframe?.contentWindow?.postMessage(request, '*');
        await this.waitForResponse(uuid);
    }
    async updateAuthentication(iframeConfiguration, token, shieldAuthType) {
        // eslint-disable-next-line no-param-reassign
        iframeConfiguration.accessToken = token;
        if (shieldAuthType === ShieldAuthType.OPENFORT && iframeConfiguration.recovery) {
            // eslint-disable-next-line no-param-reassign
            iframeConfiguration.recovery.token = token;
        }
        await this.waitForIframeLoad();
        const uuid = this.generateShortUUID();
        const request = new UpdateAuthenticationRequest(uuid, token);
        this.iframe?.contentWindow?.postMessage(request, '*');
        try {
            await this.waitForResponse(uuid);
        }
        catch (e) {
            if (e instanceof NotConfiguredError) {
                await this.configure(iframeConfiguration);
                await this.updateAuthentication(iframeConfiguration, token, shieldAuthType);
                return;
            }
            throw e;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    generateShortUUID(length = 8) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
}

class Openfort {
    signer;
    authManager;
    config;
    backendApiClients;
    instanceManager;
    iframeManager;
    openfortEventEmitter;
    constructor(sdkConfiguration) {
        this.config = new SDKConfiguration(sdkConfiguration);
        this.backendApiClients = new BackendApiClients(this.config.openfortAPIConfig);
        this.instanceManager = new InstanceManager(new SessionStorage(), new LocalStorage(), new LocalStorage(), this.config, this.backendApiClients);
        this.authManager = new AuthManager(this.config, this.backendApiClients, this.instanceManager);
        this.openfortEventEmitter = new TypedEventEmitter();
        this.iframeManager = new IframeManager(this.config);
    }
    /**
     * Logs the user out by flushing the signer and removing credentials.
     */
    async logout() {
        await this.flushSigner();
        if (this.credentialsProvided()) {
            const accessToken = this.instanceManager.getAccessToken();
            if (accessToken
                && !accessToken.thirdPartyProvider
                && !accessToken.thirdPartyTokenType) {
                const refreshToken = this.instanceManager.getRefreshToken();
                if (refreshToken === null) {
                    console.error('Refresh token is missing; cannot complete logout.');
                    return;
                }
                try {
                    await this.authManager.logout(accessToken.token, refreshToken);
                }
                catch (e) {
                    console.error('Error logging out', e);
                }
            }
            this.instanceManager.removeAccessToken();
            this.instanceManager.removeRefreshToken();
            this.instanceManager.removePlayerID();
            this.instanceManager.removeAccountAddress();
            this.instanceManager.removeAccountType();
            this.instanceManager.removeChainID();
            this.instanceManager.removeDeviceID();
            this.instanceManager.removeJWK();
            this.instanceManager.removeShieldAuthType();
            this.instanceManager.removeShieldAuthToken();
        }
    }
    /**
     * Returns an Ethereum provider using the configured signer.
     *
     * @param options - Configuration options for the Ethereum provider.
     * @returns A Provider instance.
     * @throws {OpenfortError} If the signer is not an EmbeddedSigner.
     */
    getEthereumProvider(options = { announceProvider: true }) {
        if ((this.signer instanceof SessionSigner)) {
            throw new OpenfortError('Embedded signer must be configured to get Ethereum provider', OpenfortErrorType.NOT_LOGGED_IN_ERROR);
        }
        const provider = new EvmProvider({
            openfortEventEmitter: this.openfortEventEmitter,
            signer: this.signer,
            instanceManager: this.instanceManager,
            backendApiClients: this.backendApiClients,
            policyId: options.policy,
        });
        if (options?.announceProvider) {
            announceProvider({
                info: openfortProviderInfo,
                provider,
            });
        }
        return provider;
    }
    /**
     * Configures a session key and returns the session key details.
     *
     * @returns A SessionKey object containing the address and registration status.
     */
    configureSessionKey() {
        if (this.instanceManager.getSignerType() === SignerType.EMBEDDED) {
            throw new OpenfortError('Session signer must be configured to sign a session', OpenfortErrorType.MISSING_SESSION_SIGNER_ERROR);
        }
        const signer = new SessionSigner(this.instanceManager);
        this.signer = signer;
        const publicKey = signer.loadKeys();
        if (!publicKey) {
            const newPublicKey = signer.generateKeys();
            return { address: newPublicKey, isRegistered: false };
        }
        this.instanceManager.setSignerType(SignerType.SESSION);
        return { address: publicKey, isRegistered: true };
    }
    /**
     * Configures an embedded signer.
     *
     * @param chainId - The chain ID for the embedded signer.
     * @param shieldAuthentication - Shield authentication details.
     * @param recoveryPassword - Recovery password.
     */
    async configureEmbeddedSigner(chainId, shieldAuthentication, recoveryPassword) {
        await this.validateAndRefreshToken();
        if (shieldAuthentication) {
            this.instanceManager.setShieldAuthType(shieldAuthentication?.auth);
            if (shieldAuthentication?.auth === ShieldAuthType.CUSTOM) {
                this.instanceManager.setShieldAuthToken(shieldAuthentication?.token);
            }
        }
        try {
            const signer = this.newEmbeddedSigner(chainId);
            await signer.ensureEmbeddedAccount(shieldAuthentication?.encryptionSession, recoveryPassword);
            this.signer = signer;
            this.instanceManager.setSignerType(SignerType.EMBEDDED);
        }
        catch (e) {
            if (e instanceof MissingRecoveryPasswordError || e instanceof MissingProjectEntropyError) {
                await this.flushSigner();
                throw e;
            }
        }
    }
    /**
     * Logs in a user with email and password.
     *
     * @param email - User's email.
     * @param password - User's password.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An AuthResponse object containing authentication details.
     */
    async logInWithEmailPassword({ email, password, ecosystemGame }) {
        this.logout();
        const result = await this.authManager.loginEmailPassword(email, password, ecosystemGame);
        this.storeCredentials({
            player: result.player.id,
            accessToken: result.token,
            refreshToken: result.refreshToken,
        });
        return result;
    }
    /**
     * Signs up a new user with email and password.
     *
     * @param email - User's email.
     * @param password - User's password.
     * @param options - Additional options for the sign-up process.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An AuthResponse object containing authentication details.
     */
    async signUpWithEmailPassword({ email, password, options, ecosystemGame, }) {
        this.logout();
        const result = await this.authManager.signupEmailPassword(email, password, options?.data.name, ecosystemGame);
        this.storeCredentials({
            player: result.player.id,
            accessToken: result.token,
            refreshToken: result.refreshToken,
        });
        return result;
    }
    /**
     * Links an email and password to an existing account using an authentication token.
     *
     * @param email - User's email.
     * @param password - User's password.
     * @param authToken - Authentication token.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An AuthPlayerResponse object.
     */
    async linkEmailPassword({ email, password, authToken, ecosystemGame, }) {
        return await this.authManager.linkEmail(email, password, authToken, ecosystemGame);
    }
    /**
     * Unlinks an email and password from an existing account using an authentication token.
     *
     * @param email - User's email.
     * @param authToken - Authentication token.
     * @returns An AuthPlayerResponse object.
     */
    async unlinkEmailPassword({ email, authToken }) {
        return await this.authManager.unlinkEmail(email, authToken);
    }
    /**
     * Requests an email verification link.
     *
     * @param email - User's email.
     * @param redirectUrl - Redirect URL after verification.
     */
    async requestEmailVerification({ email, redirectUrl }) {
        await this.authManager.requestEmailVerification(email, redirectUrl);
    }
    /**
     * Resets the user's password.
     *
     * @param email - User's email.
     * @param password - New password.
     * @param state - Verification state.
     */
    async resetPassword({ email, password, state }) {
        await this.authManager.resetPassword(email, password, state);
    }
    /**
     * Requests a password reset link.
     *
     * @param email - User's email.
     * @param redirectUrl - Redirect URL after resetting password.
     */
    async requestResetPassword({ email, redirectUrl }) {
        await this.authManager.requestResetPassword(email, redirectUrl);
    }
    /**
     * Verifies the user's email.
     *
     * @param email - User's email.
     * @param state - Verification state.
     */
    async verifyEmail({ email, state }) {
        await this.authManager.verifyEmail(email, state);
    }
    /**
     * Initializes an OAuth authentication process.
     *
     * @param provider - OAuth provider.
     * @param options - Additional options for initialization.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An InitAuthResponse object.
     */
    async initOAuth({ provider, options, ecosystemGame }) {
        this.logout();
        return await this.authManager.initOAuth(provider, options, ecosystemGame);
    }
    /**
     * Initializes an OAuth linking process.
     *
     * @param provider - OAuth provider.
     * @param authToken - Authentication token.
     * @param options - Additional options for initialization.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An InitAuthResponse object.
     */
    async initLinkOAuth({ provider, authToken, options, ecosystemGame, }) {
        return await this.authManager.linkOAuth(provider, authToken, options, ecosystemGame);
    }
    /**
     * Unlinks an OAuth provider from the account.
     *
     * @param provider - OAuth provider.
     * @param authToken - Authentication token.
     * @returns An AuthPlayerResponse object.
     */
    async unlinkOAuth({ provider, authToken }) {
        return await this.authManager.unlinkOAuth(provider, authToken);
    }
    /**
     * Polls for OAuth authentication completion.
     *
     * @param key - OAuth polling key.
     * @returns An AuthResponse object.
     */
    async poolOAuth(key) {
        return await this.authManager.poolOAuth(key);
    }
    /**
     * Authenticates using a third-party OAuth provider.
     *
     * @param provider - Third-party OAuth provider.
     * @param token - OAuth token.
     * @param tokenType - Type of the OAuth token.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns An AuthPlayerResponse object.
     */
    async authenticateWithThirdPartyProvider({ provider, token, tokenType, ecosystemGame, }) {
        const result = await this.authManager.authenticateThirdParty(provider, token, tokenType, ecosystemGame);
        this.instanceManager.setAccessToken({
            token,
            thirdPartyProvider: provider,
            thirdPartyTokenType: tokenType,
        });
        this.instanceManager.setPlayerID(result.id);
        if (this.signer && this.signer.useCredentials()) {
            try {
                await this.signer.updateAuthentication();
            }
            catch (e) {
                if (e instanceof MissingRecoveryPasswordError || e instanceof MissingProjectEntropyError) {
                    await this.flushSigner();
                }
                throw e;
            }
        }
        return result;
    }
    /**
     * Initializes Sign-In with Ethereum (SIWE).
     *
     * @param address - Ethereum address.
     * @param ecosystemGame - In case of ecosystem, the game that wants to authenticate.
     * @returns A SIWEInitResponse object.
     */
    async initSIWE({ address, ecosystemGame }) {
        return await this.authManager.initSIWE(address, ecosystemGame);
    }
    /**
     * Authenticates using Sign-In with Ethereum (SIWE).
     *
     * @param signature - SIWE signature.
     * @param message - SIWE message.
     * @param walletClientType - Wallet client type.
     * @param connectorType - Connector type.
     * @returns An AuthResponse object.
     */
    async authenticateWithSIWE({ signature, message, walletClientType, connectorType, }) {
        this.instanceManager.removeAccessToken();
        this.instanceManager.removeRefreshToken();
        this.instanceManager.removePlayerID();
        const result = await this.authManager.authenticateSIWE(signature, message, walletClientType, connectorType);
        this.storeCredentials({
            player: result.player.id,
            accessToken: result.token,
            refreshToken: result.refreshToken,
        });
        return result;
    }
    /**
     * Links a wallet using SIWE.
     *
     * @param signature - SIWE signature.
     * @param message - SIWE message.
     * @param walletClientType - Wallet client type.
     * @param connectorType - Connector type.
     * @param authToken - Authentication token.
     * @returns An AuthPlayerResponse object.
     */
    async linkWallet({ signature, message, walletClientType, connectorType, authToken, }) {
        return await this.authManager.linkWallet(signature, message, walletClientType, connectorType, authToken);
    }
    /**
     * Unlinks a wallet.
     *
     * @param address - Wallet address.
     * @param authToken - Authentication token.
     * @returns An AuthPlayerResponse object.
     */
    async unlinkWallet({ address, authToken }) {
        return await this.authManager.unlinkWallet(address, authToken);
    }
    /**
     * Stores authentication credentials.
     *
     * @param auth - Authentication details.
     */
    storeCredentials(auth) {
        this.instanceManager.setAccessToken({
            token: auth.accessToken,
            thirdPartyProvider: null,
            thirdPartyTokenType: null,
        });
        this.instanceManager.setRefreshToken(auth.refreshToken);
        if (auth.player)
            this.instanceManager.setPlayerID(auth.player);
    }
    /**
     * Sends a signature transaction intent request.
     *
     * @param transactionIntentId - Transaction intent ID.
     * @param userOperationHash - User operation hash.
     * @param signature - Transaction signature.
     * @param optimistic - Whether the request is optimistic.
     * @returns A TransactionIntentResponse object.
     * @throws {OpenfortError} If no userOperationHash or signature is provided.
     */
    async sendSignatureTransactionIntentRequest(transactionIntentId, userOperationHash = null, signature = null, optimistic = false) {
        let newSignature = signature;
        if (!newSignature) {
            if (!userOperationHash) {
                throw new OpenfortError('No userOperationHash or signature provided', OpenfortErrorType.OPERATION_NOT_SUPPORTED_ERROR);
            }
            await this.recoverSigner();
            if (!this.signer) {
                throw new OpenfortError('In order to sign a transaction intent, a signer must be configured', OpenfortErrorType.MISSING_SIGNER_ERROR);
            }
            if (this.signer.useCredentials()) {
                await this.validateAndRefreshToken();
            }
            newSignature = await this.signer.sign(userOperationHash);
        }
        const request = {
            id: transactionIntentId,
            signatureRequest: {
                signature: newSignature,
                optimistic,
            },
        };
        const result = await this.backendApiClients.transactionIntentsApi.signature(request);
        return result.data;
    }
    /**
     * Signs a message.
     *
     * @param message - Message to sign.
     * @param options - Additional options for signing.
     * @returns The signature.
     * @throws {OpenfortError} If no signer is configured.
     */
    async signMessage(message, options) {
        await this.recoverSigner();
        if (!this.signer) {
            throw new OpenfortError('In order to sign a message, an embedded signer must be configured', OpenfortErrorType.MISSING_EMBEDDED_SIGNER_ERROR);
        }
        if (this.signer.useCredentials()) {
            await this.validateAndRefreshToken();
        }
        const { hashMessage = true, arrayifyMessage = false } = options || {};
        return await this.signer.sign(message, arrayifyMessage, hashMessage);
    }
    /**
     * Exports the private key.
     *
     * @returns The private key.
     * @throws {OpenfortError} If no signer is configured.
     */
    async exportPrivateKey() {
        await this.recoverSigner();
        if (!this.signer) {
            throw new OpenfortError('In order to sign a message, an embedded signer must be configured', OpenfortErrorType.MISSING_EMBEDDED_SIGNER_ERROR);
        }
        if (this.signer.useCredentials()) {
            await this.validateAndRefreshToken();
        }
        return await this.signer.export();
    }
    /**
     * Signs typed data.
     *
     * @param domain - EIP-712 domain.
     * @param types - Typed data types.
     * @param value - Typed data value.
     * @returns The signature.
     * @throws {OpenfortError} If no signer is configured.
     */
    async signTypedData(domain, types, value) {
        await this.recoverSigner();
        if (!this.signer) {
            throw new OpenfortError('In order to sign a message, an embedded signer must be configured', OpenfortErrorType.MISSING_EMBEDDED_SIGNER_ERROR);
        }
        if (this.signer.useCredentials()) {
            await this.validateAndRefreshToken();
        }
        let hash = _TypedDataEncoder.hash(domain, types, value);
        // eslint-disable-next-line no-param-reassign
        delete types.EIP712Domain;
        const accountType = this.instanceManager.getAccountType();
        const accountAddress = this.instanceManager.getAccountAddress();
        const chainId = this.instanceManager.getChainID();
        if (accountType === AccountType.UPGRADEABLE_V5) {
            const updatedDomain = {
                name: 'Openfort',
                version: '0.5',
                chainId: Number(chainId),
                verifyingContract: accountAddress ?? undefined,
            };
            const updatedTypes = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                OpenfortMessage: [{ name: 'hashedMessage', type: 'bytes32' }],
            };
            const updatedMessage = {
                hashedMessage: hash,
            };
            hash = _TypedDataEncoder.hash(updatedDomain, updatedTypes, updatedMessage);
            // primaryType: "OpenfortMessage"
        }
        return await this.signer.sign(hash, false, false);
    }
    /**
     * Sends a transaction signed with a session request.
     *
     * @param sessionId - Session ID.
     * @param signature - Session signature.
     * @param optimistic - Whether the request is optimistic.
     * @returns A SessionResponse object.
     */
    async sendSignatureSessionRequest(sessionId, signature, optimistic) {
        const request = {
            id: sessionId,
            signatureRequest: {
                signature,
                optimistic,
            },
        };
        const result = await this.backendApiClients.sessionsApi.signatureSession(request);
        return result.data;
    }
    /**
     * Gets the embedded state of the current session.
     *
     * @returns The embedded state.
     */
    getEmbeddedState() {
        if (!this.credentialsProvided()) {
            return EmbeddedState.UNAUTHENTICATED;
        }
        if (this.instanceManager.getSignerType() !== SignerType.EMBEDDED) {
            return EmbeddedState.EMBEDDED_SIGNER_NOT_CONFIGURED;
        }
        if (!this.signer) {
            this.signer = this.newEmbeddedSigner();
        }
        if (!this.instanceManager.getDeviceID()) {
            return EmbeddedState.CREATING_ACCOUNT;
        }
        return EmbeddedState.READY;
    }
    /**
     * Gets the current access token.
     *
     * @returns The access token, or null if not available.
     */
    getAccessToken() {
        return this.instanceManager.getAccessToken()?.token ?? null;
    }
    /**
     * Retrieves the user details.
     *
     * @returns An AuthPlayerResponse object.
     * @throws {OpenfortError} If no access token is found.
     */
    async getUser() {
        await this.validateAndRefreshToken();
        const accessToken = this.instanceManager.getAccessToken();
        if (!accessToken) {
            throw new OpenfortError('No accessToken found', OpenfortErrorType.NOT_LOGGED_IN_ERROR);
        }
        return await this.authManager.getUser(accessToken.token);
    }
    /**
     * Validates and refreshes the access token if needed.
     */
    async validateAndRefreshToken(forceRefresh) {
        const authType = this.credentialsProvided();
        if (!authType) {
            throw new OpenfortError('Must be logged in to validate and refresh token', OpenfortErrorType.NOT_LOGGED_IN_ERROR);
        }
        if (authType === AuthType.OPENFORT) {
            const auth = await this.authManager.validateCredentials(forceRefresh);
            this.storeCredentials(auth);
            if (this.signer && this.signer.useCredentials()) {
                try {
                    await this.signer.updateAuthentication();
                }
                catch (e) {
                    if (e instanceof MissingRecoveryPasswordError || e instanceof MissingProjectEntropyError) {
                        await this.flushSigner();
                    }
                    throw e;
                }
            }
        }
    }
    credentialsProvided() {
        const token = this.instanceManager.getAccessToken();
        const refreshToken = this.instanceManager.getRefreshToken();
        if (!token) {
            return null;
        }
        if (token.token && token.thirdPartyProvider && token.thirdPartyTokenType) {
            return AuthType.THIRD_PARTY;
        }
        if (token.token && refreshToken) {
            return AuthType.OPENFORT;
        }
        return null;
    }
    async recoverSigner() {
        if (this.signer) {
            return;
        }
        const signerType = this.instanceManager.getSignerType();
        if (signerType === SignerType.EMBEDDED) {
            await this.configureEmbeddedSigner();
            return;
        }
        if (signerType === SignerType.SESSION) {
            this.configureSessionKey();
            return;
        }
        await this.waitSigner();
    }
    async waitSigner() {
        const retries = 100;
        const delay = 100;
        const checkSignerType = async (attempt) => {
            if (attempt >= retries) {
                return;
            }
            const signerType = this.instanceManager.getSignerType();
            if (signerType) {
                return;
            }
            await new Promise((resolve) => {
                setTimeout(resolve, delay);
            });
            await checkSignerType(attempt + 1);
        };
        await checkSignerType(0);
    }
    newEmbeddedSigner(chainId) {
        if (!this.credentialsProvided()) {
            throw new OpenfortError('Must be logged in to configure embedded signer', OpenfortErrorType.NOT_LOGGED_IN_ERROR);
        }
        const shieldAuthType = this.instanceManager.getShieldAuthType();
        const token = shieldAuthType === ShieldAuthType.OPENFORT
            ? this.instanceManager.getAccessToken()?.token
            : this.instanceManager.getShieldAuthToken();
        if (!token) {
            throw new OpenfortError('Shield auth token is not set', OpenfortErrorType.INVALID_CONFIGURATION);
        }
        const shieldAuth = {
            auth: shieldAuthType,
            token,
            authProvider: this.instanceManager.getAccessToken()?.thirdPartyProvider ?? undefined,
            tokenType: this.instanceManager.getAccessToken()?.thirdPartyTokenType ?? undefined,
        };
        const iframeConfiguration = {
            accessToken: this.instanceManager.getAccessToken()?.token ?? null,
            playerID: this.instanceManager.getPlayerID() ?? null,
            thirdPartyProvider: this.instanceManager.getAccessToken()?.thirdPartyProvider ?? null,
            thirdPartyTokenType: this.instanceManager.getAccessToken()?.thirdPartyTokenType ?? null,
            chainId: !chainId ? Number(this.instanceManager.getChainID()) ?? null : chainId,
            recovery: shieldAuth,
        };
        return new EmbeddedSigner(this.iframeManager, this.instanceManager, iframeConfiguration);
    }
    async flushSigner() {
        if (this.signer) {
            await this.signer.logout();
            this.instanceManager.removeSignerType();
            return;
        }
        const signerType = this.instanceManager.getSignerType();
        switch (signerType) {
            case SignerType.EMBEDDED: {
                const iframeConfiguration = {
                    accessToken: this.instanceManager.getAccessToken()?.token ?? null,
                    playerID: this.instanceManager.getPlayerID() ?? null,
                    thirdPartyProvider: this.instanceManager.getAccessToken()?.thirdPartyProvider ?? null,
                    thirdPartyTokenType: this.instanceManager.getAccessToken()?.thirdPartyTokenType ?? null,
                    chainId: null,
                    recovery: null,
                };
                const embeddedSigner = new EmbeddedSigner(this.iframeManager, this.instanceManager, iframeConfiguration);
                await embeddedSigner.logout();
                break;
            }
            case SignerType.SESSION:
                this.configureSessionKey();
                break;
        }
        this.instanceManager.removeSignerType();
    }
}

export { AuthType, BasicAuthProvider, EmbeddedState, OAuthProvider, OpenfortConfiguration, OpenfortError, OpenfortErrorType, SDKConfiguration, ShieldAuthType, ShieldConfiguration, ThirdPartyOAuthProvider, TokenType, Openfort as default };
